<script>
import Layout from '@layouts/main'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import formProduto from '@/src/components/form-produto'
import formCultura from '@/src/components/form-cultura'
import formPraga from '@/src/components/form-praga.vue'

import Service from '@/src/services/itens_produto'

import Praga from '@src/services/pragas'
import Cultura from '@src/services/culturas'
import Produto from '@src/services/produto'
import LocalAplicacao from '@src/services/local_aplicacao'
import TipoAplicacao from '@src/services/tipo-aplicacao'
import Unidade from '@src/services/unidade'
import EpocaALvo from '@src/services/epoca-alvo'
import RestricoesEstado from '@src/services/restricoes-estado'
import NewProd from '@/src/services/newprod'

/**
 * Dashboard-1 Component
 */
export default {
  components: { Layout, Loading, formProduto, formCultura, formPraga },
  data() {
    return {
      selectedItemProdutoEquipamento: null,
      selectedCulture: [],
      cultures: [],
      itemProdutoEdit: {},
      itemProdutoReport: {},
      itens_produto: [],
      itens_produto_equipamento: [],
      itemProdutoFields: [
        {
          key: 'selected',
          label: '',
          class: 'size-col-10 relation-col-select',
        },
        {
          key: 'id_produto',
          label: 'Produto',
          class: 'size-col-40 relation-col-product',
        },
        {
          key: 'id_cultura',
          label: 'Cultura',
          class: 'size-col-40 relation-col-cultura',
        },
        {
          key: 'id_pragas',
          label: 'Alvo',
          class: 'size-col-40 relation-col-alvo',
        },
        {
          key: 'id_tipo_aplicacao',
          label: 'Detalhes',
          class: 'size-col-40 relation-col-details',
        },
        { key: 'actions', label: '', class: 'size-col-10 relation-col-actions' },
      ],
      equipamentosItemProdutoFields: [
        {
          key: 'nomeProduto',
          label: 'Produto',
          class: 'size-col-20',
        },
        {
          key: 'nomeCultura',
          label: 'Cultura',
          class: 'size-col-20',
        },
        {
          key: 'nomePraga',
          label: 'Alvo',
          class: 'size-col-20',
        },
        {
          key: 'tipoAplicacao',
          label: 'Tipo Aplicação',
          class: 'size-col-20',
        },
        { key: 'manual', label: 'Pulverizadores manuais', class: 'size-col-10' },
        { key: 'costal', label: 'Pulverização costal', class: 'size-col-10' },
        { key: 'tratorizado', label: 'Pulverizador tratorizado', class: 'size-col-10' },
        { key: 'tratorizado_barra', label: 'Pulverização tratorizada com barra', class: 'size-col-10' },
        { key: 'aerea', label: 'Aplicação Aérea', class: 'size-col-10' },
        { key: 'drone', label: 'Aplicação ARP (Drones)', class: 'size-col-10' },
      ],
      currentPage: 1,
      perPage: 20,
      showModal: false,
      isLoading: false,
      idProduto: '',
      rows: 0,
      inlineFormMode: '',
      inlineForm: null,
      selectedItemIds: [],
      bulkEditRows: [],
      bulkEditActiveCell: null,
      bulkApplyForm: {
        dose_min: '',
        dose_max: '',
        id_unidade_aplic: '',
        volume_calda_min: '',
        volume_calda: '',
        id_unidade: '',
        id_tipo_aplicacao: '',
        id_local_aplicacao: '',
        numero_aplicacoes_min: '',
        numero_aplicacoes_max: '',
        intervalo_seguranca: '',
        id_epoca_praga: '',
        id_epoca_alvo: '',
      },
      replicateBaseItem: null,
      replicateRows: [],
      replicateExpandedRows: {},
      locaisAplicacao: [],
      tiposAplicacao: [],
      unidades: [],
      epocasAlvo: [],
      pragas: [],
      pragasFiltradas: [],
      produtos: [],
      culturas: [],
      culturasFiltradas: [],
      showProdutoCadastroModal: false,
      showCulturaCadastroModal: false,
      showPragaCadastroModal: false,
      showImportBulaModal: false,
      showProdutoImportModal: false,
      showComparativoCulturasModal: false,
      produtoCadastroModal: {},
      culturaCadastroModal: {},
      pragaCadastroModal: {},
      numeroRegistroInput: '',
      importLoading: false,
      lastImportResponse: null,
      comparativoCulturasLoading: false,
      comparativoCulturasRaw: null,
      comparativoCulturasData: null,
      comparativoSelectedMissingCulturas: [],
      comparativoCulturasForm: {
        id_produto: '',
      },
      bulaImportForm: {
        arquivo: null,
        observacoes: '',
        id_produto: '',
      },
      bulaImportSourceUrl: '',
      bulaImportAgrofitData: null,
      bulaImportCulturasOptions: [],
      bulaImportSelectedCulturas: [],
      bulaImportCulturasLoading: false,
      bulaImportPreviewUrl: '',
      bulaImportPreviewName: '',
      filter: {
        id_pragas: '',
        id_cultura: '',
        id_produto: '',
      },
    }
  },
  computed: {
    filteredItems() {
      if (this.selectedCulture.includes(null) || this.selectedCulture.length === 0) {
        return this.itens_produto_equipamento;
      }
      return this.itens_produto_equipamento.filter(item =>
        this.selectedCulture.includes(item.nomeCultura)
      );
    },
    culturasFiltroOptions() {
      return this.filter.id_produto ? this.culturasFiltradas : this.culturas
    },
    pragasFiltroOptions() {
      return this.filter.id_produto ? this.pragasFiltradas : this.pragas
    },
    allCurrentItemsSelected() {
      return this.itens_produto.length > 0 && this.itens_produto.every((item) => this.selectedItemIds.includes(item.id_item_produto))
    },
    selectedItemsCount() {
      return this.selectedItemIds.length
    },
    bulkFieldLabels() {
      return {
        id_produto: 'Produto',
        id_cultura: 'Cultura',
        id_pragas: 'Alvo',
        id_tipo_aplicacao: 'Tipo',
        dose_min: 'Dose mínima',
        dose_max: 'Dose máxima',
        id_unidade_aplic: 'Unidade da dose',
        volume_calda_min: 'Calda mínima',
        volume_calda: 'Calda máxima',
        id_unidade: 'Unidade da calda',
        numero_aplicacoes_min: 'Aplicações mín.',
        numero_aplicacoes_max: 'Aplicações máx.',
        intervalo_seguranca: 'Intervalo de segurança',
        id_local_aplicacao: 'Local',
        id_epoca_praga: 'Estágio alvo',
        id_epoca_alvo: 'Estágio cultura',
        desc_modo_aplicacao: 'Desc. modo aplicação',
      }
    },
    canReplicateActiveField() {
      return Boolean(
        this.bulkEditActiveCell &&
        this.bulkEditRows.length > 1 &&
        this.bulkFieldLabels[this.bulkEditActiveCell.field]
      )
    },
    bulaImportSuggestedPrompt() {
      return this.buildBulaImportPrompt()
    }
  },

  watch: {
    currentPage() {
      this.listar()
    },
    'filter.id_produto'() {
      this.loadProdutoFilterOptions()
    },
    'bulaImportForm.id_produto'(value) {
      this.handleBulaImportProdutoChange(value)
    },
    'comparativoCulturasForm.id_produto'(value) {
      this.handleComparativoProdutoChange(value)
    },
  },
  mounted() {
    this.listar()
    this.handleGet()
  },
  methods: {
    async confirmarImportProduto() {
      this.importLoading = true
      this.lastImportResponse = null

      try {
        const token = this.$store.state.auth.currentUser.token
        const resposta = await NewProd.register(token, this.numeroRegistroInput)

        this.lastImportResponse = resposta.data || resposta

        const msg = this.lastImportResponse.message || this.lastImportResponse.msg || 'Importação realizada com sucesso!'
        this.$bvToast.toast(
          msg,
          {
            variant: 'success',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          }
        )

        this.showProdutoImportModal = false
        this.numeroRegistroInput = ''
        this.lastImportResponse = null
        this.handleGet()
      } catch (error) {
        const payload = error.response && error.response.data ? error.response.data : { message: 'Erro desconhecido' }
        const msgErr = payload.message || payload.msg || 'Erro ao realizar importação. Tente novamente.'

        this.$bvToast.toast(
          msgErr,
          {
            variant: 'danger',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          }
        )
      } finally {
        this.importLoading = false
      }
    },
    loading(a) {
      a = !this.isLoading ? true : false
      return a
    },
    buildUniqueRelationOptions(items = [], relationKey, idKey) {
      const optionsMap = new Map()

      items.forEach((item) => {
        const relation = item && item[relationKey] ? item[relationKey] : null
        const relationId = relation && relation[idKey] ? relation[idKey] : null

        if (relation && relationId && !optionsMap.has(relationId)) {
          optionsMap.set(relationId, relation)
        }
      })

      return Array.from(optionsMap.values())
    },
    loadProdutoFilterOptions() {
      if (!this.filter.id_produto) {
        this.culturasFiltradas = []
        this.pragasFiltradas = []
        return
      }

      const token = this.$store.state.auth.currentUser.token
      const filter = {
        id_pragas: '',
        id_cultura: '',
        id_produto: this.filter.id_produto,
      }

      Service.listar(
        token,
        1000,
        1,
        JSON.stringify(filter)
      ).then((resposta) => {
        const items = Array.isArray(resposta.data.dados) ? resposta.data.dados : []
        this.culturasFiltradas = this.buildUniqueRelationOptions(items, 'id_cultura', 'id_cultura')
        this.pragasFiltradas = this.buildUniqueRelationOptions(items, 'id_pragas', 'id_pragas')

        const culturaSelecionadaExiste = this.culturasFiltradas.some(
          (item) => item.id_cultura === this.filter.id_cultura
        )
        const pragaSelecionadaExiste = this.pragasFiltradas.some(
          (item) => item.id_pragas === this.filter.id_pragas
        )

        if (this.filter.id_cultura && !culturaSelecionadaExiste) {
          this.filter.id_cultura = ''
        }

        if (this.filter.id_pragas && !pragaSelecionadaExiste) {
          this.filter.id_pragas = ''
        }
      })
    },
    async listar() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true

      try {
        const hasFilter =
          this.filter.id_pragas !== '' ||
          this.filter.id_cultura !== '' ||
          this.filter.id_produto !== ''

        const resposta = hasFilter
          ? await Service.listar(
            token,
            this.perPage,
            this.currentPage,
            JSON.stringify(this.filter)
          )
          : await Service.listar(token, this.perPage, this.currentPage)

        this.itens_produto = resposta.data.dados
        this.selectedItemIds = this.selectedItemIds.filter((id) =>
          this.itens_produto.some((item) => item.id_item_produto === id)
        )
        this.rows = resposta.headers['x-total-count']

        this.itens_produto_equipamento = []
        this.cultures = []

        this.itens_produto.forEach((item) => {
          const modifiedItem = {
            id: item.id_item_produto,
            nomeProduto: item.id_produto ? item.id_produto.nome : 'Produto não encontrado',
            nomeCultura: item.id_cultura ? item.id_cultura.nome_comum : 'Cultura não encontrada',
            nomePraga: item.id_pragas ? item.id_pragas.nome_comum : 'Praga não encontrada',
            tipoAplicacao: item.id_tipo_aplicacao ? item.id_tipo_aplicacao.nome : 'Tipo de aplicação não encontrado',
            manual: false,
            costal: false,
            tratorizado: false,
            tratorizadoBarra: false,
            aerea: false,
            drone: false,
            manualCaldaMin: item.volume_calda_min,
            manualCaldaMax: item.volume_calda,
            costalCaldaMin: item.volume_calda_min,
            costalCaldaMax: item.volume_calda,
            tratorizadoCaldaMin: item.volume_calda_min,
            tratorizadoCaldaMax: item.volume_calda,
            tratorizadoBarraCaldaMin: item.volume_calda_min,
            tratorizadoBarraCaldaMax: item.volume_calda,
            aereaCaldaMin: '',
            aereaCaldaMax: '',
            droneCaldaMin: '',
            droneCaldaMax: '',
            volume_calda: item.volume_calda,
            volume_calda_min: item.volume_calda_min,
          }

          this.itens_produto_equipamento.push(modifiedItem)
          this.cultures.push({ value: modifiedItem.nomeCultura, text: modifiedItem.nomeCultura })
        })
      } catch (erro) {
        this.$bvToast.toast('Não foi possível carregar a listagem de relações.', {
          variant: 'danger',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
      } finally {
        this.isLoading = false
      }
    },
    handleGet() {
      const token = this.$store.state.auth.currentUser.token
      Praga.listar(token).then((response) => {
        this.pragas = response.data.dados
      })
      Produto.listar(token).then((response) => {
        this.produtos = response.data.dados
      })
      Cultura.listar(token).then((response) => {
        this.culturas = response.data.dados
      })
      LocalAplicacao.listar(token).then((response) => {
        this.locaisAplicacao = response.data.dados
      })
      TipoAplicacao.listar(token).then((response) => {
        this.tiposAplicacao = response.data.dados
      })
      Unidade.listar(token).then((response) => {
        this.unidades = response.data.dados
      })
      EpocaALvo.listar(token).then((response) => {
        this.epocasAlvo = response.data.dados
      })
    },
    openProdutoCadastroModal() {
      this.showProdutoImportModal = true
    },
    openCulturaCadastroModal() {
      this.culturaCadastroModal = {}
      this.showCulturaCadastroModal = true
    },
    openPragaCadastroModal() {
      this.pragaCadastroModal = {}
      this.showPragaCadastroModal = true
    },
    openImportBulaModal() {
      if (this.filter.id_produto) {
        this.bulaImportForm.id_produto = this.filter.id_produto
      }
      this.showImportBulaModal = true
      if (this.bulaImportForm.id_produto) {
        this.$nextTick(() => {
          this.handleBulaImportProdutoChange(this.bulaImportForm.id_produto)
        })
      }
    },
    openComparativoCulturasModal() {
      this.comparativoCulturasForm.id_produto = this.filter.id_produto || ''
      this.comparativoCulturasData = null
      this.showComparativoCulturasModal = true

      if (this.comparativoCulturasForm.id_produto) {
        this.$nextTick(() => {
          this.handleComparativoProdutoChange(this.comparativoCulturasForm.id_produto)
        })
      }
    },
    handleCadastroRelacionamentoHidden() {
      this.produtoCadastroModal = {}
      this.culturaCadastroModal = {}
      this.pragaCadastroModal = {}
      this.handleGet()
    },
    resetBulaImportModal() {
      if (this.bulaImportPreviewUrl) {
        URL.revokeObjectURL(this.bulaImportPreviewUrl)
      }
      this.bulaImportPreviewUrl = ''
      this.bulaImportPreviewName = ''
      this.bulaImportSourceUrl = ''
      this.bulaImportForm = {
        arquivo: null,
        observacoes: '',
        id_produto: this.filter.id_produto || '',
      }
      this.bulaImportAgrofitData = null
      this.bulaImportCulturasOptions = []
      this.bulaImportSelectedCulturas = []
      this.bulaImportCulturasLoading = false
    },
    resetComparativoCulturasModal() {
      this.comparativoCulturasLoading = false
      this.comparativoCulturasRaw = null
      this.comparativoCulturasData = null
      this.comparativoSelectedMissingCulturas = []
      this.comparativoCulturasForm = {
        id_produto: this.filter.id_produto || '',
      }
    },
    handleBulaFileChange(file) {
      if (this.bulaImportPreviewUrl) {
        URL.revokeObjectURL(this.bulaImportPreviewUrl)
      }

      this.bulaImportForm.arquivo = file || null
      this.bulaImportSourceUrl = ''
      this.bulaImportPreviewName = file && file.name ? file.name : ''
      this.bulaImportPreviewUrl = file && file.type && file.type.startsWith('image/')
        ? URL.createObjectURL(file)
        : ''
    },
    applySuggestedBulaPrompt() {
      this.bulaImportForm.observacoes = this.buildBulaImportPrompt()
    },
    getProdutoMapa(produtoId) {
      const produto = this.produtos.find((item) => String(item.id_produto) === String(produtoId))
      if (!produto) return ''

      const mapa =
        produto.mapa ||
        produto.numero_registro ||
        produto.numeroRegistro ||
        produto.nr_registro ||
        ''

      return mapa ? String(mapa).trim() : ''
    },
    extractAgrofitProductPayload(response) {
      const payload = response && response.data ? response.data : response
      if (Array.isArray(payload)) return payload[0] || null
      if (payload && Array.isArray(payload.dados)) return payload.dados[0] || null
      if (payload && Array.isArray(payload.data)) return payload.data[0] || null
      if (payload && payload.produto) return payload.produto
      if (payload && payload.resultado) return payload.resultado
      if (payload && payload.dados && !Array.isArray(payload.dados)) return payload.dados
      if (payload && payload.data && !Array.isArray(payload.data)) return payload.data
      return payload || null
    },
    buildAgrofitCultureOptions(produtoData) {
      const entries = Array.isArray(produtoData && produtoData.indicacao_uso)
        ? produtoData.indicacao_uso
        : []
      const cultureMap = new Map()

      entries.forEach((entry) => {
        const cultura = entry && entry.cultura ? String(entry.cultura).trim() : ''
        if (!cultura) return

        if (!cultureMap.has(cultura)) {
          cultureMap.set(cultura, {
            value: cultura,
            text: cultura,
            alvos: new Set(),
          })
        }

        const current = cultureMap.get(cultura)
        const commonNames = Array.isArray(entry.praga_nome_comum)
          ? entry.praga_nome_comum
          : entry.praga_nome_comum && entry.praga_nome_comum !== 'Ausente'
            ? [entry.praga_nome_comum]
            : []
        const scientificName = entry && entry.praga_nome_cientifico ? String(entry.praga_nome_cientifico).trim() : ''
        ;[...commonNames, scientificName].forEach((alvo) => {
          if (alvo) current.alvos.add(alvo)
        })
      })

      return Array.from(cultureMap.values())
        .map((item) => ({
          ...item,
          alvos: Array.from(item.alvos),
        }))
        .sort((a, b) => a.text.localeCompare(b.text))
    },
    async handleBulaImportProdutoChange(produtoId) {
      this.bulaImportAgrofitData = null
      this.bulaImportCulturasOptions = []
      this.bulaImportSelectedCulturas = []

      if (!produtoId || !this.showImportBulaModal) return

      const mapa = this.getProdutoMapa(produtoId)
      if (!mapa) {
        this.$bvToast.toast('O produto selecionado não possui número MAPA disponível para consultar culturas no Agrofit.', {
          variant: 'warning',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
        return
      }

      this.bulaImportCulturasLoading = true

      try {
        const token = this.$store.state.auth.currentUser.token
        const response = await NewProd.consulta(token, mapa, true)
        const produtoData = this.extractAgrofitProductPayload(response)

        this.bulaImportAgrofitData = produtoData
        this.bulaImportCulturasOptions = this.buildAgrofitCultureOptions(produtoData)
        this.bulaImportSelectedCulturas = this.bulaImportCulturasOptions.map((item) => item.value)

        if (!this.bulaImportCulturasOptions.length) {
          this.$bvToast.toast('A consulta ao Agrofit não retornou culturas para esse produto.', {
            variant: 'warning',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
        }
      } catch (error) {
        this.bulaImportAgrofitData = null
        this.bulaImportCulturasOptions = []
        this.$bvToast.toast('Não foi possível carregar as culturas do Agrofit para o produto selecionado.', {
          variant: 'danger',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
      } finally {
        this.bulaImportCulturasLoading = false
      }
    },
    toggleAllBulaCulturas(checked) {
      this.bulaImportSelectedCulturas = checked
        ? this.bulaImportCulturasOptions.map((item) => item.value)
        : []
    },
    buildBulaImportPrompt() {
      const selectedCultures = this.bulaImportCulturasOptions.filter((item) =>
        this.bulaImportSelectedCulturas.includes(item.value)
      )
      const agrofitProduct = this.bulaImportAgrofitData || {}
      const marca = Array.isArray(agrofitProduct.marca_comercial)
        ? agrofitProduct.marca_comercial.join(', ')
        : agrofitProduct.marca_comercial || ''
      const tecnicas = Array.isArray(agrofitProduct.tecnica_aplicacao)
        ? agrofitProduct.tecnica_aplicacao.filter(Boolean).join(', ')
        : ''
      const ingredientes = Array.isArray(agrofitProduct.ingrediente_ativo)
        ? agrofitProduct.ingrediente_ativo.filter(Boolean).join('; ')
        : ''
      const cultureInstruction = selectedCultures.length
        ? `Considere prioritariamente apenas estas culturas confirmadas no Agrofit: ${selectedCultures.map((item) => item.text).join(', ')}. Ignore recomendacoes de culturas diferentes.`
        : this.bulaImportCulturasOptions.length
          ? `Use como referencia somente culturas presentes no Agrofit para este produto: ${this.bulaImportCulturasOptions.map((item) => item.text).join(', ')}.`
          : ''

      return [
        'Analise o PDF ou a imagem enviada e extraia somente dados estruturados de uso agricola para cadastro de relacoes no WebReceita.',
        marca ? `Produto esperado: ${marca}.` : '',
        agrofitProduct.numero_registro ? `Numero de registro MAPA de referencia: ${agrofitProduct.numero_registro}.` : '',
        ingredientes ? `Ingredientes ativos de apoio para validacao: ${ingredientes}.` : '',
        tecnicas ? `Tecnicas de aplicacao registradas no Agrofit: ${tecnicas}. Use isso apenas como contexto e nao invente relacoes.` : '',
        cultureInstruction,
        'Priorize encontrar e retornar: produto, cultura, alvo/praga, dose minima, dose maxima, unidade da dose, calda minima, calda maxima, unidade da calda, numero minimo de aplicacoes, numero maximo de aplicacoes, intervalo de seguranca, estagio do alvo, estagio da cultura, local de aplicacao, descricao do modo de aplicacao e descricao do volume de calda.',
        'Considere apenas trechos que representem recomendacoes reais de uso da bula. Ignore secoes institucionais, advertencias gerais, composicao, fabricante, toxicologia, primeiros socorros e blocos sem relacao direta com recomendacao agronomica.',
        'Se houver varias culturas ou varios alvos, gere uma relacao separada para cada combinacao identificada.',
        'Para alvo/praga, aproveite nome comum e nome cientifico quando existirem.',
        'Interprete o texto buscando o melhor encaixe com o cadastro do WebReceita. Para estagio do alvo e estagio da cultura, devolva a melhor interpretacao textual possivel a partir do contexto da bula.',
        'Na descricao do volume de calda, monte um texto objetivo no formato: Volume de calda de X ate Y UNIDADE.',
        'Na descricao do modo de aplicacao, consolide o texto operacional relevante da bula em linguagem clara, sem repetir blocos desnecessarios.',
        'Quando algum campo nao estiver explicito, deixe vazio em vez de inventar valor.',
        'Retorne os dados de forma estruturada e focada apenas nas relacoes aproveitaveis para cadastro.'
      ].filter(Boolean).join(' ')
    },
    extractComparativoCulturasPayload(response) {
      const payload = response && response.data ? response.data : response
      if (payload && Array.isArray(payload.comparativos)) return payload.comparativos[0] || null
      if (payload && payload.data && Array.isArray(payload.data.comparativos)) return payload.data.comparativos[0] || null
      return payload || null
    },
    normalizeComparativoProduct(source, fallbackName = '-') {
      if (!source) {
        return {
          title: fallbackName,
          meta: [],
        }
      }

      if (typeof source === 'string') {
        return {
          title: source,
          meta: [],
        }
      }

      const title =
        source.nome_comercial ||
        source.nome ||
        source.produto ||
        source.marca_comercial ||
        fallbackName

      const marcas = Array.isArray(source.marcas)
        ? source.marcas.filter(Boolean).join(', ')
        : Array.isArray(source.marca_comercial)
          ? source.marca_comercial.filter(Boolean).join(', ')
          : ''

      const meta = [
        source.numero_registro || source.mapa ? `MAPA ${source.numero_registro || source.mapa}` : '',
        marcas && marcas !== title ? `Marcas: ${marcas}` : '',
      ].filter(Boolean)

      return { title, meta }
    },
    normalizeComparativoCultureEntry(entry) {
      if (entry === null || entry === undefined || entry === '') {
        return {
          title: '-',
          meta: [],
          match: false,
        }
      }

      if (typeof entry === 'string') {
        return {
          title: entry,
          meta: [],
          match: false,
        }
      }

      const title =
        entry.cultura_webreceita ||
        entry.cultura_agrofit ||
        entry.nome ||
        entry.cultura ||
        '-'

      const meta = [
        entry.nome_cientifico ? `Científico: ${entry.nome_cientifico}` : '',
        entry.id_cultura ? `ID ${entry.id_cultura}` : '',
      ].filter(Boolean)

      return {
        title,
        meta,
        match: Boolean(entry.match_por_nome || entry.match || entry.em_comum),
      }
    },
    getComparativoCultureKey(entry, prefix = 'entry') {
      if (typeof entry === 'string') return `${prefix}-${entry}`
      if (!entry || typeof entry !== 'object') return `${prefix}-empty`
      return `${prefix}-${entry.id_cultura || ''}-${entry.cultura_agrofit || entry.cultura_webreceita || entry.nome || entry.cultura || ''}-${entry.nome_cientifico || ''}`
    },
    getComparativoMissingSelectionValue(entry) {
      const normalized = this.normalizeComparativoCultureEntry(entry)
      return JSON.stringify({
        title: normalized.title,
        scientific: entry && typeof entry === 'object' ? (entry.nome_cientifico || '') : '',
      })
    },
    getComparativoAgrofitPdfUrl() {
      const comparativo = this.comparativoCulturasData || {}
      const raw = this.comparativoCulturasRaw || {}
      const produto = this.comparativoCulturasData && this.comparativoCulturasData.produto_agrofit
        ? this.comparativoCulturasData.produto_agrofit
        : null

      if (!produto || typeof produto !== 'object') return ''

      const documentos = Array.isArray(produto.documento_cadastrado) ? produto.documento_cadastrado : []
      const preferredDocument = documentos.find((documento) => {
        const tipo = documento && documento.tipo_documento ? String(documento.tipo_documento).toLowerCase() : ''
        const origem = documento && documento.origem ? String(documento.origem).toLowerCase() : ''
        const descricao = documento && documento.descricao ? String(documento.descricao).toLowerCase() : ''
        return tipo.includes('bula') || origem.includes('bula') || descricao.includes('bula')
      })

      return (
        raw.arquivo_url ||
        raw.url_bula ||
        raw.link_bula ||
        raw.url ||
        comparativo.arquivo_url ||
        comparativo.url_bula ||
        comparativo.link_bula ||
        comparativo.url ||
        (produto && produto.url_bula_pdf) ||
        (preferredDocument && preferredDocument.url) ||
        (documentos[0] && documentos[0].url) ||
        produto.url_bula ||
        produto.link_bula ||
        ''
      )
    },
    getComparativoAgrofitPdfPayload() {
      const comparativo = this.comparativoCulturasData || {}
      const raw = this.comparativoCulturasRaw || {}
      const produto = comparativo.produto_agrofit && typeof comparativo.produto_agrofit === 'object'
        ? comparativo.produto_agrofit
        : {}

      const candidates = [
        raw.arquivo_bula,
        raw.bula_pdf,
        raw.pdf_base64,
        raw.base64_pdf,
        raw.pdf,
        raw.arquivo,
        raw.file,
        raw.content,
        raw.conteudo,
        raw.body,
        raw.data,
        comparativo.arquivo_bula,
        comparativo.bula_pdf,
        comparativo.pdf_base64,
        comparativo.base64_pdf,
        comparativo.pdf,
        comparativo.arquivo,
        produto.arquivo_bula,
        produto.bula_pdf,
        produto.pdf_base64,
        produto.base64_pdf,
        produto.pdf,
        produto.arquivo,
      ]

      for (const candidate of candidates) {
        if (!candidate) continue
        return candidate
      }

      const documentos = Array.isArray(produto.documento_cadastrado) ? produto.documento_cadastrado : []
      const documentoComArquivo = documentos.find((documento) =>
        documento && (
          documento.arquivo ||
          documento.pdf ||
          documento.base64 ||
          documento.pdf_base64 ||
          documento.bula_pdf
        )
      )

      return documentoComArquivo || null
    },
    findNestedPdfCandidate(source, depth = 0, seen = new WeakSet()) {
      if (!source || depth > 4) return null

      if (source instanceof File || source instanceof Blob || source instanceof ArrayBuffer || ArrayBuffer.isView(source)) {
        return source
      }

      if (typeof source === 'string') {
        const trimmed = source.trim()
        if (!trimmed) return null

        const looksLikeBase64 = trimmed.startsWith('data:application/pdf;base64,')
          || trimmed.startsWith('JVBERi0')
          || /^[A-Za-z0-9+/=\s]+$/.test(trimmed)

        if (looksLikeBase64 || trimmed.startsWith('http')) {
          return trimmed
        }
        return null
      }

      if (typeof source !== 'object') return null
      if (seen.has(source)) return null
      seen.add(source)

      const preferredKeys = [
        'arquivo_bula',
        'bula_pdf',
        'pdf_base64',
        'base64_pdf',
        'pdf',
        'arquivo',
        'file',
        'content',
        'conteudo',
        'body',
        'data',
        'url',
        'arquivo_url',
        'link_bula',
        'url_bula',
      ]

      for (const key of preferredKeys) {
        if (source[key]) {
          const candidate = this.findNestedPdfCandidate(source[key], depth + 1, seen)
          if (candidate) return candidate
        }
      }

      const values = Array.isArray(source) ? source : Object.values(source)
      for (const value of values) {
        const candidate = this.findNestedPdfCandidate(value, depth + 1, seen)
        if (candidate) return candidate
      }

      return null
    },
    createFileFromBase64Payload(base64Payload, fileName = 'bula-agrofit.pdf', fallbackMime = 'application/pdf') {
      if (!base64Payload || typeof base64Payload !== 'string') return null

      const hasDataPrefix = base64Payload.startsWith('data:')
      const mimeMatch = hasDataPrefix ? base64Payload.match(/^data:([^;]+);base64,/) : null
      const mimeType = mimeMatch && mimeMatch[1] ? mimeMatch[1] : fallbackMime
      const cleanBase64 = hasDataPrefix ? base64Payload.split(',')[1] : base64Payload

      if (!cleanBase64) return null

      const binary = atob(cleanBase64)
      const bytes = new Uint8Array(binary.length)
      for (let i = 0; i < binary.length; i += 1) {
        bytes[i] = binary.charCodeAt(i)
      }

      return new File([bytes], fileName, { type: mimeType })
    },
    createFileFromComparativoPdfPayload(payload) {
      if (!payload) return null

      if (payload instanceof File) {
        return payload
      }

      if (payload instanceof Blob) {
        return new File([payload], 'bula-agrofit.pdf', { type: payload.type || 'application/pdf' })
      }

      if (payload instanceof ArrayBuffer || ArrayBuffer.isView(payload)) {
        const bytes = payload instanceof ArrayBuffer ? payload : payload.buffer
        return new File([bytes], 'bula-agrofit.pdf', { type: 'application/pdf' })
      }

      if (typeof payload === 'string') {
        if (payload.startsWith('http')) return null
        return this.createFileFromBase64Payload(payload)
      }

      if (typeof payload !== 'object') return null

      const base64Content =
        payload.base64 ||
        payload.content ||
        payload.conteudo ||
        payload.pdf_base64 ||
        payload.bula_pdf ||
        payload.arquivo

      const fileName =
        payload.fileName ||
        payload.filename ||
        payload.nome_arquivo ||
        payload.nome ||
        'bula-agrofit.pdf'

      const mimeType =
        payload.mimeType ||
        payload.contentType ||
        payload.tipo ||
        'application/pdf'

      return base64Content
        ? this.createFileFromBase64Payload(base64Content, fileName, mimeType)
        : null
    },
    async preloadBulaImportFromUrl(url) {
      if (!url) return false

      try {
        const response = await fetch(url)
        if (!response.ok) throw new Error('Falha ao baixar arquivo da bula')

        const blob = await response.blob()
        const contentType = blob.type || 'application/pdf'
        const extension = contentType.includes('pdf') ? 'pdf' : contentType.includes('image/') ? contentType.split('/')[1] : 'pdf'
        const file = new File([blob], `bula-agrofit.${extension}`, { type: contentType })

        this.handleBulaFileChange(file)
        this.bulaImportSourceUrl = url
        return true
      } catch (error) {
        this.bulaImportSourceUrl = url
        return false
      }
    },
    async preloadBulaImportFromComparativoPayload() {
      const rawPayload = this.getComparativoAgrofitPdfPayload()
      const payload = this.findNestedPdfCandidate(rawPayload) || rawPayload
      const file = this.createFileFromComparativoPdfPayload(payload)

      if (file) {
        this.handleBulaFileChange(file)
        this.bulaImportPreviewName = file.name || 'Bula do Agrofit'
        return true
      }

      return false
    },
    async openMissingCultureCadastro(entry = null) {
      const targets = entry
        ? [entry]
        : this.comparativoSelectedMissingCulturas.map((value) => JSON.parse(value))

      if (!targets.length) {
        this.$bvToast.toast('Selecione ao menos uma cultura faltante para iniciar o cadastro da relação.', {
          variant: 'warning',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
        return
      }

      const produtoId = this.comparativoCulturasForm.id_produto || this.filter.id_produto || ''
      this.bulaImportForm.id_produto = produtoId
      this.bulaImportSelectedCulturas = targets.map((item) => item.title).filter(Boolean)
      this.bulaImportForm.observacoes = this.buildBulaImportPrompt()

      const pdfUrl = this.getComparativoAgrofitPdfUrl()
      if (this.bulaImportPreviewUrl) {
        URL.revokeObjectURL(this.bulaImportPreviewUrl)
        this.bulaImportPreviewUrl = ''
      }
      this.bulaImportPreviewName = ''
      this.bulaImportForm.arquivo = null
      this.bulaImportSourceUrl = pdfUrl || ''

      this.showComparativoCulturasModal = false
      this.showImportBulaModal = true

      this.$nextTick(async () => {
        if (produtoId) {
          await this.handleBulaImportProdutoChange(produtoId)
          this.bulaImportSelectedCulturas = targets.map((item) => item.title).filter(Boolean)
          this.bulaImportForm.observacoes = this.buildBulaImportPrompt()
        }

        let loaded = await this.preloadBulaImportFromComparativoPayload()

        if (!loaded && pdfUrl) {
          loaded = await this.preloadBulaImportFromUrl(pdfUrl)
          this.bulaImportForm.observacoes = this.buildBulaImportPrompt()

          if (!loaded) {
            this.bulaImportPreviewName = 'Bula do Agrofit'
            this.$bvToast.toast('A URL da bula foi vinculada ao modal, mas o navegador não conseguiu baixar o arquivo automaticamente.', {
              variant: 'warning',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
          }
        }

        this.bulaImportForm.observacoes = this.buildBulaImportPrompt()
      })
    },
    async handleComparativoProdutoChange(produtoId) {
      this.comparativoCulturasRaw = null
      this.comparativoCulturasData = null
      this.comparativoSelectedMissingCulturas = []

      if (!produtoId || !this.showComparativoCulturasModal) return

      const mapa = this.getProdutoMapa(produtoId)
      if (!mapa) {
        this.$bvToast.toast('O produto selecionado não possui número MAPA disponível para comparação.', {
          variant: 'warning',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
        return
      }

      this.comparativoCulturasLoading = true

      try {
        const token = this.$store.state.auth.currentUser.token
        const response = await NewProd.comparativoCulturas(token, mapa)
        this.comparativoCulturasRaw = response && response.data ? response.data : response
        this.comparativoCulturasData = this.extractComparativoCulturasPayload(response)
      } catch (error) {
        this.comparativoCulturasRaw = null
        this.comparativoCulturasData = null
        this.$bvToast.toast('Não foi possível carregar o comparativo de culturas.', {
          variant: 'danger',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
      } finally {
        this.comparativoCulturasLoading = false
      }
    },
    resolveImportedOptionValue(source, options, idKey, labelKeys = []) {
      if (source === undefined || source === null || source === '') return ''

      if (typeof source === 'object') {
        if (source[idKey]) return source[idKey]
        for (const key of labelKeys) {
          if (source[key]) {
            source = source[key]
            break
          }
        }
      }

      const exactIdMatch = (options || []).find((item) => String(item[idKey]) === String(source))
      if (exactIdMatch) return exactIdMatch[idKey]

      const normalizedSource = String(source).trim().toLowerCase()
      if (!normalizedSource) return ''

      const exactLabelMatch = (options || []).find((item) =>
        labelKeys.some((key) => item && item[key] && String(item[key]).trim().toLowerCase() === normalizedSource)
      )
      if (exactLabelMatch) return exactLabelMatch[idKey]

      const containsLabelMatch = (options || []).find((item) =>
        labelKeys.some((key) => {
          if (!item || !item[key]) return false
          const optionValue = String(item[key]).trim().toLowerCase()
          return optionValue.includes(normalizedSource) || normalizedSource.includes(optionValue)
        })
      )

      return containsLabelMatch ? containsLabelMatch[idKey] : ''
    },
    normalizeImportedItem(item = {}) {
      const imported = item && typeof item === 'object' ? item : {}

      return {
        ...this.createEmptyInlineForm(),
        ativo: imported.ativo !== false,
        id_produto: this.resolveImportedOptionValue(
          imported.id_produto || imported.produto_id || imported.produto || imported.nome_produto || imported.mapa_produto,
          this.produtos,
          'id_produto',
          ['nome', 'mapa']
        ),
        id_cultura: this.resolveImportedOptionValue(
          imported.id_cultura || imported.cultura_id || imported.cultura || imported.nome_cultura,
          this.culturas,
          'id_cultura',
          ['nome_comum', 'nome_cientifico']
        ),
        id_pragas: this.resolveImportedOptionValue(
          imported.id_pragas || imported.praga_id || imported.alvo_id || imported.praga || imported.alvo || imported.nome_alvo,
          this.pragas,
          'id_pragas',
          ['nome_comum', 'nome_cientifico']
        ),
        id_tipo_aplicacao: this.resolveImportedOptionValue(
          imported.id_tipo_aplicacao || imported.tipo_aplicacao_id || imported.tipo_aplicacao || imported.tipo || imported.metodo_aplicacao,
          this.tiposAplicacao,
          'id_tipo_aplicacao',
          ['nome']
        ),
        id_unidade_aplic: this.resolveImportedOptionValue(
          imported.id_unidade_aplic || imported.id_unidade_dose || imported.unidade_dose || imported.unidade_aplicacao,
          this.unidades,
          'id_unidade',
          ['unid1']
        ),
        id_unidade: this.resolveImportedOptionValue(
          imported.id_unidade || imported.id_unidade_calda || imported.unidade_calda,
          this.unidades,
          'id_unidade',
          ['unid1']
        ),
        id_local_aplicacao: this.resolveImportedOptionValue(
          imported.id_local_aplicacao || imported.local_aplicacao_id || imported.local_aplicacao || imported.local,
          this.locaisAplicacao,
          'id_local_aplicacao',
          ['nome']
        ),
        id_epoca_praga: this.resolveImportedOptionValue(
          imported.id_epoca_praga || imported.estagio_alvo_id || imported.estagio_alvo,
          this.epocasAlvo,
          'id_epoca_alvo',
          ['descricao']
        ),
        id_epoca_alvo: this.resolveImportedOptionValue(
          imported.id_epoca_alvo || imported.estagio_cultura_id || imported.estagio_cultura,
          this.epocasAlvo,
          'id_epoca_alvo',
          ['descricao']
        ),
        dose_min: imported.dose_min || imported.doseMin || '',
        dose_max: imported.dose_max || imported.doseMax || '',
        volume_calda_min: imported.volume_calda_min || imported.calda_min || imported.volumeCaldaMin || '',
        volume_calda: imported.volume_calda || imported.calda_max || imported.volumeCaldaMax || '',
        numero_aplicacoes_min: imported.numero_aplicacoes_min || imported.aplicacoes_min || imported.numeroAplicacoesMin || '',
        numero_aplicacoes_max: imported.numero_aplicacoes_max || imported.aplicacoes_max || imported.numeroAplicacoesMax || '',
        intervalo_seguranca: imported.intervalo_seguranca || imported.intervalo || imported.intervaloSeguranca || '',
        desc_dose: imported.desc_dose || imported.descricao_dose || '',
        desc_modo_aplicacao: imported.desc_modo_aplicacao || imported.descricao_modo_aplicacao || '',
        desc_volume_calda: imported.desc_volume_calda || imported.descricao_volume_calda || '',
      }
    },
    normalizeImportedRows(payload = {}) {
      const data = payload && typeof payload === 'object' ? payload : {}
      const rows =
        data.dados ||
        data.data ||
        data.items ||
        data.rows ||
        data.relacoes ||
        data.relations ||
        []

      if (!Array.isArray(rows)) return []
      return rows.map((item) => this.createImportedBulkEditRow(item))
    },
    normalizeItemProduto(item = {}) {
      return {
        id_item_produto: item.id_item_produto,
        aplic_area: item.aplic_area,
        ativo: item.ativo ? true : false,
        desc_dose: item.desc_dose || '',
        desc_modo_aplicacao: item.desc_modo_aplicacao || '',
        desc_volume_calda: item.desc_volume_calda || '',
        dose_max: item.dose_max || '',
        dose_min: item.dose_min || '',
        id_cultura: item.id_cultura ? item.id_cultura.id_cultura : '',
        id_epoca_alvo: item.id_epoca_alvo,
        id_epoca_praga: item.id_epoca_praga,
        id_local_aplicacao: item.id_local_aplicacao,
        id_pragas: item.id_pragas ? item.id_pragas.id_pragas : '',
        id_produto: item.id_produto ? item.id_produto.id_produto : '',
        id_tipo_aplicacao: item.id_tipo_aplicacao ? item.id_tipo_aplicacao.id_tipo_aplicacao : '',
        id_unidade: item.id_unidade,
        id_unidade_aplic: item.id_unidade_aplic,
        intervalo_seguranca: item.intervalo_seguranca || '',
        numero_aplicacoes_max: item.numero_aplicacoes_max || '',
        numero_aplicacoes_min: item.numero_aplicacoes_min || '',
        restricoes_estado: item.restricoes_estado || [],
        volume_calda: item.volume_calda || '',
        volume_calda_min: item.volume_calda_min || '',
      }
    },
    createEmptyInlineForm() {
      return {
        aplic_area: '',
        ativo: true,
        desc_dose: '',
        desc_modo_aplicacao: '',
        desc_volume_calda: '',
        dose_max: '',
        dose_min: '',
        id_cultura: '',
        id_epoca_alvo: '',
        id_epoca_praga: '',
        id_local_aplicacao: '',
        id_pragas: '',
        id_produto: '',
        id_tipo_aplicacao: '',
        id_unidade: '',
        id_unidade_aplic: '',
        intervalo_seguranca: '',
        numero_aplicacoes_max: '',
        numero_aplicacoes_min: '',
        restricoes_estado: [],
        volume_calda: '',
        volume_calda_min: '',
      }
    },
    createReplicateRow(baseItem = {}) {
      const row = this.normalizeItemProduto(baseItem)
      delete row.id_item_produto
      row.ativo = row.ativo !== false
      row.restricoes_estado = Array.isArray(row.restricoes_estado) ? [...row.restricoes_estado] : []
      return row
    },
    async startInlineEdit(item) {
      this.inlineFormMode = 'edit'
      this.inlineForm = this.normalizeItemProduto(item)

      try {
        const token = this.$store.state.auth.currentUser.token
        const response = await RestricoesEstado.listarPorRestricao(
          token,
          item.id_item_produto
        )
        this.inlineForm.restricoes_estado = Array.isArray(response.data.dados)
          ? response.data.dados.map((restricao) => restricao.id_estado.id_estado)
          : []
      } catch (error) {
        this.inlineForm.restricoes_estado = []
      }
    },
    startInlineCreate() {
      this.inlineFormMode = 'create'
      this.inlineForm = this.createEmptyInlineForm()
    },
    cancelInlineForm() {
      this.inlineFormMode = ''
      this.inlineForm = null
    },
    async saveInlineForm() {
      if (!this.inlineForm) return

      const token = this.$store.state.auth.currentUser.token
      const payload = {
        ...this.inlineForm,
        restricoes_estado: this.inlineForm.restricoes_estado || [],
      }

      this.isLoading = true

      try {
        const resposta = payload.id_item_produto
          ? await Service.update(token, payload)
          : await Service.salvar(token, payload)

        const sucessoCadastro = !payload.id_item_produto && resposta.data && resposta.data.sucesso === false
        if (sucessoCadastro) {
          this.$bvToast.toast(resposta.data.mensagem, {
            variant: 'danger',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          return
        }

        this.$bvToast.toast(payload.id_item_produto ? 'Atualizado com sucesso' : 'Salvo com sucesso!', {
          variant: 'success',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })

        this.cancelInlineForm()
        await this.listar()
      } catch (erro) {
        const message =
          erro.response && erro.response.data
            ? erro.response.data.data || erro.response.data.message || erro.response.data.mensagem
            : 'Erro inesperado'

        this.$bvToast.toast(Array.isArray(message) ? message.join(', ') : message, {
          variant: 'danger',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
      } finally {
        this.isLoading = false
      }
    },
    toggleSelectedItem(itemId, checked) {
      if (!itemId) return

      if (checked) {
        if (!this.selectedItemIds.includes(itemId)) {
          this.selectedItemIds = [...this.selectedItemIds, itemId]
        }
        return
      }

      this.selectedItemIds = this.selectedItemIds.filter((id) => id !== itemId)
    },
    toggleSelectAllCurrentItems(checked) {
      if (!checked) {
        this.selectedItemIds = this.selectedItemIds.filter(
          (id) => !this.itens_produto.some((item) => item.id_item_produto === id)
        )
        return
      }

      const nextIds = new Set(this.selectedItemIds)
      this.itens_produto.forEach((item) => nextIds.add(item.id_item_produto))
      this.selectedItemIds = Array.from(nextIds)
    },
    toggleSelectedArrayValue(target, value, checked) {
      const current = Array.isArray(this[target]) ? [...this[target]] : []
      if (checked) {
        if (!current.includes(value)) current.push(value)
      } else {
        return this.$set(this, target, current.filter((item) => item !== value))
      }
      this.$set(this, target, current)
    },
    createBulkEditRow(item) {
      return {
        ...this.normalizeItemProduto(item),
        bulk_row_key: `${item.id_item_produto || 'new'}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
        nome_produto: item.id_produto ? item.id_produto.nome : '-',
        nome_cultura: item.id_cultura ? item.id_cultura.nome_comum : '-',
        nome_alvo: item.id_pragas ? item.id_pragas.nome_comum : '-',
        tipo_aplicacao_nome: item.id_tipo_aplicacao ? item.id_tipo_aplicacao.nome : '-',
      }
    },
    createNewBulkEditRow() {
      return {
        ...this.createEmptyInlineForm(),
        bulk_row_key: `new-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      }
    },
    createImportedBulkEditRow(item = {}) {
      return {
        ...this.normalizeImportedItem(item),
        bulk_row_key: `import-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      }
    },
    openBulkEditModal() {
      const selectedItems = this.itens_produto.filter((item) =>
        this.selectedItemIds.includes(item.id_item_produto)
      )

      if (!selectedItems.length) {
        this.$bvToast.toast('Selecione ao menos um item para editar.', {
          variant: 'warning',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
        return
      }

      this.bulkEditRows = selectedItems.map((item) => this.createBulkEditRow(item))
      this.$bvModal.show('modal-bulk-edit-items')
    },
    openBulkCreateModal() {
      this.bulkEditRows = [this.createNewBulkEditRow()]
      this.$bvModal.show('modal-bulk-edit-items')
    },
    addBulkEditRow() {
      this.bulkEditRows.push(this.createNewBulkEditRow())
    },
    async importBulaContent() {
      if (!this.bulaImportForm.arquivo && !this.bulaImportSourceUrl) {
        this.$bvToast.toast('Selecione um arquivo PDF ou imagem da bula para continuar.', {
          variant: 'warning',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
        return
      }

      const token = this.$store.state.auth.currentUser.token
      const formData = new FormData()
      if (this.bulaImportForm.arquivo) {
        formData.append('arquivo', this.bulaImportForm.arquivo)
      }

      if (this.bulaImportSourceUrl) {
        formData.append('arquivo_url', this.bulaImportSourceUrl)
      }

      if (this.bulaImportForm.observacoes) {
        formData.append('observacoes', this.bulaImportForm.observacoes)
      }

      if (this.bulaImportForm.id_produto) {
        formData.append('id_produto', this.bulaImportForm.id_produto)
      }

      this.isLoading = true

      try {
        const response = await Service.importarBula(token, formData)
        const extractedRows = this.normalizeImportedRows(response.data)

        if (!extractedRows.length) {
          this.$bvToast.toast('A extração não retornou relações prontas. Você pode ajustar o endpoint para devolver uma lista de itens-produto.', {
            variant: 'warning',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          return
        }

        this.bulkEditRows = extractedRows
        this.showImportBulaModal = false
        this.$bvModal.show('modal-bulk-edit-items')
        this.$bvToast.toast('Dados da bula carregados no editor. Revise e salve as relações.', {
          variant: 'success',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
      } catch (erro) {
        const message =
          erro.response && erro.response.data
            ? erro.response.data.data || erro.response.data.message || erro.response.data.mensagem
            : 'Não foi possível processar o arquivo da bula.'

        this.$bvToast.toast(Array.isArray(message) ? message.join(', ') : message, {
          variant: 'danger',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
      } finally {
        this.isLoading = false
      }
    },
    resetBulkEditModal() {
      this.bulkEditRows = []
      this.bulkEditActiveCell = null
      this.bulkApplyForm = {
        dose_min: '',
        dose_max: '',
        id_unidade_aplic: '',
        volume_calda_min: '',
        volume_calda: '',
        id_unidade: '',
        id_tipo_aplicacao: '',
        id_local_aplicacao: '',
        numero_aplicacoes_min: '',
        numero_aplicacoes_max: '',
        intervalo_seguranca: '',
        id_epoca_praga: '',
        id_epoca_alvo: '',
      }
    },
    setBulkActiveCell(rowId, field) {
      this.bulkEditActiveCell = {
        rowId,
        field,
      }
    },
    startBulkCellEdit(rowId, field) {
      this.setBulkActiveCell(rowId, field)
    },
    stopBulkCellEdit() {
      this.bulkEditActiveCell = null
    },
    isBulkCellEditing(rowId, field) {
      return (
        this.bulkEditActiveCell &&
        this.bulkEditActiveCell.rowId === rowId &&
        this.bulkEditActiveCell.field === field
      )
    },
    getBulkFieldLabel(field) {
      return this.bulkFieldLabels[field] || 'Campo'
    },
    buildVolumeCaldaDescription(row) {
      const caldaMin = row && row.volume_calda_min !== '' && row.volume_calda_min !== null && row.volume_calda_min !== undefined
        ? row.volume_calda_min
        : '-'
      const caldaMax = row && row.volume_calda !== '' && row.volume_calda !== null && row.volume_calda !== undefined
        ? row.volume_calda
        : '-'
      const unidadeCalda = row && row.id_unidade
        ? this.getUnidadeLabel(row.id_unidade)
        : ''
      const unidadeTexto = unidadeCalda && unidadeCalda !== '-' ? ` ${unidadeCalda}` : ''

      if (caldaMin === '-' && caldaMax === '-' && !unidadeTexto) {
        return '-'
      }

      return `Volume de calda de ${caldaMin} a ${caldaMax}${unidadeTexto}`.trim()
    },
    copyBulkEditRow(row) {
      if (!row) return

      const clonedRow = {
        ...row,
        bulk_row_key: `new-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      }

      delete clonedRow.id_item_produto
      this.bulkEditRows.push(clonedRow)
    },
    replicateActiveBulkField() {
      if (!this.canReplicateActiveField) {
        return
      }

      const { rowId, field } = this.bulkEditActiveCell
      const sourceRow = this.bulkEditRows.find((row) => row.bulk_row_key === rowId)

      if (!sourceRow) return

      let affectedRows = 0

      this.bulkEditRows = this.bulkEditRows.map((row) => {
        if (row.bulk_row_key === rowId) {
          return row
        }

        affectedRows += 1
        return {
          ...row,
          [field]: sourceRow[field],
        }
      })

      if (affectedRows > 0) {
        this.$bvToast.toast(`${this.getBulkFieldLabel(field)} replicado(a) para ${affectedRows} linha(s).`, {
          variant: 'success',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
      }
    },
    removeBulkEditRow(rowKey) {
      if (!rowKey) return

      this.bulkEditRows = this.bulkEditRows.filter((row) => row.bulk_row_key !== rowKey)

      if (
        this.bulkEditActiveCell &&
        this.bulkEditActiveCell.rowId === rowKey
      ) {
        this.bulkEditActiveCell = null
      }

      if (!this.bulkEditRows.length) {
        this.bulkEditRows = [this.createNewBulkEditRow()]
      }
    },
    applyBulkEditValues() {
      if (!this.bulkEditRows.length) return

      const editableFields = [
        'dose_min',
        'dose_max',
        'id_unidade_aplic',
        'volume_calda_min',
        'volume_calda',
        'id_unidade',
        'id_tipo_aplicacao',
        'id_local_aplicacao',
        'numero_aplicacoes_min',
        'numero_aplicacoes_max',
        'intervalo_seguranca',
        'id_epoca_praga',
        'id_epoca_alvo',
      ]

      this.bulkEditRows = this.bulkEditRows.map((row) => {
        const nextRow = { ...row }
        editableFields.forEach((field) => {
          if (this.bulkApplyForm[field] !== '' && this.bulkApplyForm[field] !== null) {
            nextRow[field] = this.bulkApplyForm[field]
          }
        })
        return nextRow
      })

      this.$bvToast.toast('Valores aplicados aos itens selecionados.', {
        variant: 'success',
        solid: false,
        noCloseButton: true,
        toaster: 'b-toaster-top-center',
      })
    },
    async saveBulkEditRows() {
      if (!this.bulkEditRows.length) return

      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true

      try {
        for (const row of this.bulkEditRows) {
          const payload = { ...row }
          delete payload.bulk_row_key
          delete payload.nome_produto
          delete payload.nome_cultura
          delete payload.nome_alvo
          delete payload.tipo_aplicacao_nome
          payload.desc_dose = '-'
          payload.desc_volume_calda = this.buildVolumeCaldaDescription(payload)
          if (payload.id_item_produto) {
            await Service.update(token, payload)
          } else {
            await Service.salvar(token, payload)
          }
        }

        this.$bvToast.toast('Itens atualizados com sucesso.', {
          variant: 'success',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
        this.$bvModal.hide('modal-bulk-edit-items')
        this.resetBulkEditModal()
        this.listar()
      } catch (erro) {
        const message =
          erro.response && erro.response.data
            ? erro.response.data.data || erro.response.data.message || erro.response.data.mensagem
            : 'Erro inesperado'

        this.$bvToast.toast(Array.isArray(message) ? message.join(', ') : message, {
          variant: 'danger',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
      } finally {
        this.isLoading = false
      }
    },
    editRegister(item) {
      this.startInlineEdit(item)
    },
    copyRegister(item) {
      this.replicateBaseItem = item
      this.replicateRows = [this.createReplicateRow(item)]
      this.replicateExpandedRows = { 0: true }
      this.$bvModal.show('modal-replicate-item')
    },
    addReplicateRow() {
      if (!this.replicateBaseItem) return
      this.replicateRows.push(this.createReplicateRow(this.replicateBaseItem))
      this.replicateExpandedRows = {
        ...this.replicateExpandedRows,
        [this.replicateRows.length - 1]: true,
      }
    },
    duplicateReplicateRow(index) {
      const currentRow = this.replicateRows[index]
      if (!currentRow) return
      this.replicateRows.splice(index + 1, 0, {
        ...currentRow,
        restricoes_estado: Array.isArray(currentRow.restricoes_estado) ? [...currentRow.restricoes_estado] : [],
      })
      const expandedRows = {}
      this.replicateRows.forEach((row, rowIndex) => {
        if (rowIndex <= index) {
          expandedRows[rowIndex] = !!this.replicateExpandedRows[rowIndex]
        } else if (rowIndex === index + 1) {
          expandedRows[rowIndex] = true
        } else {
          expandedRows[rowIndex] = !!this.replicateExpandedRows[rowIndex - 1]
        }
      })
      this.replicateExpandedRows = expandedRows
    },
    removeReplicateRow(index) {
      if (this.replicateRows.length === 1) return
      this.replicateRows.splice(index, 1)
      const expandedRows = {}
      this.replicateRows.forEach((row, rowIndex) => {
        expandedRows[rowIndex] = rowIndex >= index
          ? !!this.replicateExpandedRows[rowIndex + 1]
          : !!this.replicateExpandedRows[rowIndex]
      })
      this.replicateExpandedRows = expandedRows
    },
    resetReplicateModal() {
      this.replicateBaseItem = null
      this.replicateRows = []
      this.replicateExpandedRows = {}
    },
    toggleReplicateDetails(index) {
      this.replicateExpandedRows = {
        ...this.replicateExpandedRows,
        [index]: !this.replicateExpandedRows[index],
      }
    },
    async saveReplicatedItems() {
      if (!this.replicateRows.length) return

      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true

      try {
        for (let index = 0; index < this.replicateRows.length; index += 1) {
          const payload = {
            ...this.replicateRows[index],
            restricoes_estado: this.replicateRows[index].restricoes_estado || [],
          }

          const response = await Service.salvar(token, payload)
          if (response.data && response.data.sucesso === false) {
            throw new Error(response.data.mensagem || `Falha ao salvar a linha ${index + 1}.`)
          }
        }

        this.$bvToast.toast('Relações replicadas com sucesso!', {
          variant: 'success',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
        this.$bvModal.hide('modal-replicate-item')
        this.resetReplicateModal()
        this.listar()
      } catch (error) {
        const message =
          error.response && error.response.data
            ? error.response.data.data || error.response.data.message || error.response.data.mensagem
            : error.message || 'Erro inesperado'

        this.$bvToast.toast(Array.isArray(message) ? message.join(', ') : message, {
          variant: 'danger',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
      } finally {
        this.isLoading = false
      }
    },
    showReport(item) {
      this.itemProdutoReport = item
      this.$bvModal.show('modal-report')
    },
    getBulaLink(item) {
      const produto = item && item.id_produto ? item.id_produto : {}
      return (
        produto.link_bula ||
        produto.url_bula ||
        produto.bula ||
        produto.bula_pdf ||
        produto.arquivo_bula ||
        ''
      )
    },
    resolveOptionLabel(source, options, idKey, labelKey) {
      if (!source) return '-'
      if (typeof source === 'object' && source[labelKey]) return source[labelKey]

      const option = (options || []).find((item) => item && item[idKey] === source)
      return option && option[labelKey] ? option[labelKey] : '-'
    },
    getLocalAplicacaoLabel(item) {
      return this.resolveOptionLabel(
        item && item.id_local_aplicacao,
        this.locaisAplicacao,
        'id_local_aplicacao',
        'nome'
      )
    },
    getTipoAplicacaoLabel(source) {
      return this.resolveOptionLabel(
        source,
        this.tiposAplicacao,
        'id_tipo_aplicacao',
        'nome'
      )
    },
    getProdutoLabel(source) {
      return this.resolveOptionLabel(
        source,
        this.produtos,
        'id_produto',
        'nome'
      )
    },
    getCulturaLabel(source) {
      return this.resolveOptionLabel(
        source,
        this.culturas,
        'id_cultura',
        'nome_comum'
      )
    },
    getPragaLabel(source) {
      return this.resolveOptionLabel(
        source,
        this.pragas,
        'id_pragas',
        'nome_comum'
      )
    },
    getUnidadeLabel(source) {
      return this.resolveOptionLabel(
        source,
        this.unidades,
        'id_unidade',
        'unid1'
      )
    },
    getEpocaAlvoLabel(value) {
      return this.resolveOptionLabel(value, this.epocasAlvo, 'id_epoca_alvo', 'descricao')
    },
    modalDelete(id) {
      this.$bvModal.show('modal-delete')
      this.idProduto = id
    },
    Deletar() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.isLoading)
      Service.deletar(token, this.idProduto)
        .then((resposta) => {
          this.listar()
          this.isLoading = this.loading(this.isLoading)
        })
        .catch((err) => {
          this.isLoading = this.loading(this.isLoading)
          this.$bvToast.toast(
            'Ocorreu um erro ao deletar, verifique se o item está sendo utilizado em outro lugar.',
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
        })
      this.idProduto = null
      this.$bvModal.hide('modal-delete')
    },
    saveEquipamentos() {
      this.isLoading = true
      const token = this.$store.state.auth.currentUser.token
      console.log(this.filteredItems);
      Service.salvarEquipament(token, this.filteredItems)
        .then((resposta) => {
          this.isLoading = false
          this.$bvModal.hide('modal-create-equipament')
          this.$bvToast.toast('Equipamentos criados com sucesso!', {
            variant: 'success',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          this.listar()
        })
        .catch((err) => {
          this.isLoading = false
          this.$bvToast.toast(
            'Ocorreu um erro ao salvar equipamentos',
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
        })
    }
  },
}
</script>

<template>
  <Layout>
    <div class="bloco">
      <div class="cabecalho">
        <div class="row">
          <div class="col-md-11">
            <div class="titulo">Relações</div>
            <div class="subTitulo">Visualize, edite e cadastre novas relações na plataforma.</div>
          </div>
          <div class="col-md-1 cadastra">
            <button class="btn btn-webreceita" @click="openBulkCreateModal">
              <span>Novo</span>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="borda"></div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">
            <b-form-group id="input-group-1" label="Produto" label-for="filter">
              <v-select class="style-select" label="nome" :options="produtos" :reduce="(item) => item.id_produto"
                v-model="filter.id_produto" :dense="true"></v-select>
              <button class="btn relation-helper-btn" @click.prevent="openProdutoCadastroModal">
                Cadastrar produto
              </button>
              <button class="btn relation-helper-btn relation-helper-btn-secondary" @click.prevent="openComparativoCulturasModal">
                Comparar culturas
              </button>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group id="input-group-1" label="Culturas" label-for="filter">
              <v-select class="style-select" label="nome_comum" :options="culturasFiltroOptions" :reduce="(item) => item.id_cultura"
                v-model="filter.id_cultura"></v-select>
              <button class="btn relation-helper-btn" @click.prevent="openCulturaCadastroModal">
                Cadastrar cultura
              </button>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group id="input-group-1" label="Alvo" label-for="filter">
              <v-select class="style-select style-select-rich" label="nome_comum" :options="pragasFiltroOptions" :reduce="(item) => item.id_pragas"
                v-model="filter.id_pragas">
                <template #option="item">
                  <div class="select-rich-option">
                    <span class="select-rich-title">{{ item.nome_comum }}</span>
                    <span v-if="item.nome_cientifico" class="select-rich-subtitle">{{ item.nome_cientifico }}</span>
                  </div>
                </template>
                <template #selected-option="item">
                  <div class="select-rich-option select-rich-option-selected">
                    <span class="select-rich-title">{{ item.nome_comum }}</span>
                    <span v-if="item.nome_cientifico" class="select-rich-subtitle">{{ item.nome_cientifico }}</span>
                  </div>
                </template>
              </v-select>
              <button class="btn relation-helper-btn" @click.prevent="openPragaCadastroModal">
                Cadastrar praga
              </button>
            </b-form-group>
          </div>

          <div class="col-md-2">
            <button class="btn btn-webreceita" @click.prevent="listar">Filtrar</button>
          </div>
          <div class="col-md-2">
            <button class="btn import-bula-trigger w-100" @click.prevent="openImportBulaModal">
              Importar da bula
            </button>
          </div>
          <div class="col-md-2">
            <button
              class="btn bulk-edit-trigger w-100"
              :disabled="!selectedItemsCount"
              @click.prevent="openBulkEditModal"
            >
              <span>Editar seleção</span>
              <span v-if="selectedItemsCount" class="bulk-edit-trigger-count">{{ selectedItemsCount }}</span>
            </button>
          </div>
        </div>
      </div>
      <div>
        <div>
          <div v-if="inlineForm" class="inline-editor mb-3">
            <div class="inline-editor-header">
              <div>
                <div class="inline-editor-title">
                  {{ inlineFormMode === 'edit' ? 'Editar relação' : 'Nova relação' }}
                </div>
                <div class="inline-editor-subtitle">
                  Ajuste os dados abaixo e salve sem sair da listagem.
                </div>
              </div>
              <div class="inline-editor-header-actions">
                <div class="inline-status">
                  <b-form-checkbox v-model="inlineForm.ativo">Ativo</b-form-checkbox>
                </div>
                <button class="btn btn-webreceita mr-2" @click.prevent="saveInlineForm">Salvar</button>
                <button class="btn btn-light" @click.prevent="cancelInlineForm">Cancelar</button>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-xl-5">
                <div class="inline-editor-panel">
                  <div class="inline-editor-section-title">Relacionamento principal</div>
                  <div class="row">
                    <div class="col-md-6 col-xl-12">
                      <b-form-group label="Produto">
                        <v-select class="style-select" label="nome" :options="produtos"
                          :reduce="(item) => item.id_produto" v-model="inlineForm.id_produto"></v-select>
                      </b-form-group>
                    </div>
                    <div class="col-md-6 col-xl-12">
                      <b-form-group label="Cultura">
                        <v-select class="style-select" label="nome_comum" :options="culturas"
                          :reduce="(item) => item.id_cultura" v-model="inlineForm.id_cultura"></v-select>
                      </b-form-group>
                    </div>
                    <div class="col-md-6 col-xl-12">
                      <b-form-group label="Praga">
                        <v-select class="style-select style-select-rich" label="nome_comum" :options="pragas"
                          :reduce="(item) => item.id_pragas" v-model="inlineForm.id_pragas">
                          <template #option="item">
                            <div class="select-rich-option">
                              <span class="select-rich-title">{{ item.nome_comum }}</span>
                              <span v-if="item.nome_cientifico" class="select-rich-subtitle">{{ item.nome_cientifico }}</span>
                            </div>
                          </template>
                          <template #selected-option="item">
                            <div class="select-rich-option select-rich-option-selected">
                              <span class="select-rich-title">{{ item.nome_comum }}</span>
                              <span v-if="item.nome_cientifico" class="select-rich-subtitle">{{ item.nome_cientifico }}</span>
                            </div>
                          </template>
                        </v-select>
                      </b-form-group>
                    </div>
                    <div class="col-md-6 col-xl-12">
                      <b-form-group label="Método de Aplicação">
                        <v-select class="style-select" label="nome" :options="tiposAplicacao"
                          :reduce="(item) => item.id_tipo_aplicacao" v-model="inlineForm.id_tipo_aplicacao"></v-select>
                      </b-form-group>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 col-xl-7">
                <div class="inline-editor-panel">
                  <div class="inline-editor-section-title">Dosagem e aplicação</div>
                  <div class="row">
                    <div class="col-sm-6 col-lg-4">
                      <b-form-group label="Dose mínima">
                        <b-form-input v-model="inlineForm.dose_min" type="number"></b-form-input>
                      </b-form-group>
                    </div>
                    <div class="col-sm-6 col-lg-4">
                      <b-form-group label="Dose máxima">
                        <b-form-input v-model="inlineForm.dose_max" type="number"></b-form-input>
                      </b-form-group>
                    </div>
                    <div class="col-sm-6 col-lg-4">
                      <b-form-group label="Unidade da dose">
                        <v-select class="style-select" label="unid1" :options="unidades"
                          :reduce="(item) => item.id_unidade" v-model="inlineForm.id_unidade_aplic"></v-select>
                      </b-form-group>
                    </div>
                    <div class="col-sm-6 col-lg-4">
                      <b-form-group label="Calda min">
                        <b-form-input v-model="inlineForm.volume_calda_min" type="number"></b-form-input>
                      </b-form-group>
                    </div>
                    <div class="col-sm-6 col-lg-4">
                      <b-form-group label="Calda max">
                        <b-form-input v-model="inlineForm.volume_calda" type="number"></b-form-input>
                      </b-form-group>
                    </div>
                    <div class="col-sm-6 col-lg-4">
                      <b-form-group label="Unidade da calda">
                        <v-select class="style-select" label="unid1" :options="unidades"
                          :reduce="(item) => item.id_unidade" v-model="inlineForm.id_unidade"></v-select>
                      </b-form-group>
                    </div>
                    <div class="col-sm-6 col-lg-4">
                      <b-form-group label="Aplicações mín.">
                        <b-form-input v-model="inlineForm.numero_aplicacoes_min" type="number"></b-form-input>
                      </b-form-group>
                    </div>
                    <div class="col-sm-6 col-lg-4">
                      <b-form-group label="Aplicações máx.">
                        <b-form-input v-model="inlineForm.numero_aplicacoes_max" type="number"></b-form-input>
                      </b-form-group>
                    </div>
                    <div class="col-sm-6 col-lg-4">
                      <b-form-group label="Intervalo de segurança">
                        <b-form-input v-model="inlineForm.intervalo_seguranca" type="number"></b-form-input>
                      </b-form-group>
                    </div>
                    <div class="col-sm-6 col-lg-4">
                      <b-form-group label="Local Aplicação">
                        <v-select class="style-select" label="nome" :options="locaisAplicacao"
                          :reduce="(item) => item.id_local_aplicacao" v-model="inlineForm.id_local_aplicacao"></v-select>
                      </b-form-group>
                    </div>
                    <div class="col-sm-6 col-lg-4">
                      <b-form-group label="Estágio do Alvo">
                        <v-select class="style-select" label="descricao" :options="epocasAlvo"
                          :reduce="(item) => item.id_epoca_alvo" v-model="inlineForm.id_epoca_praga"></v-select>
                      </b-form-group>
                    </div>
                    <div class="col-sm-6 col-lg-4">
                      <b-form-group label="Estágio da Cultura">
                        <v-select class="style-select" label="descricao" :options="epocasAlvo"
                          :reduce="(item) => item.id_epoca_alvo" v-model="inlineForm.id_epoca_alvo"></v-select>
                      </b-form-group>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="inline-editor-panel">
                  <div class="inline-editor-section-title">Descrições</div>
                  <div class="row">
                    <div class="col-md-4">
                      <b-form-group label="Descrição Dose">
                        <b-form-textarea v-model="inlineForm.desc_dose" rows="4" max-rows="4"></b-form-textarea>
                      </b-form-group>
                    </div>
                    <div class="col-md-4">
                      <b-form-group label="Descrição modo de aplicação">
                        <b-form-textarea v-model="inlineForm.desc_modo_aplicacao" rows="4" max-rows="4"></b-form-textarea>
                      </b-form-group>
                    </div>
                    <div class="col-md-4">
                      <b-form-group label="Descrição volume calda">
                        <b-form-textarea v-model="inlineForm.desc_volume_calda" rows="4" max-rows="4"></b-form-textarea>
                      </b-form-group>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <b-table striped hover responsive="sm" borderless bordered outlined small :items="itens_produto"
            :fields="itemProdutoFields" :per-page="perPage">
            <template #head(selected)>
              <b-form-checkbox
                :checked="allCurrentItemsSelected"
                @change="toggleSelectAllCurrentItems($event)"
              ></b-form-checkbox>
            </template>
            <template #cell(selected)="row">
              <div class="relation-select-cell">
                <b-form-checkbox
                  :checked="selectedItemIds.includes(row.item.id_item_produto)"
                  @change="toggleSelectedItem(row.item.id_item_produto, $event)"
                ></b-form-checkbox>
              </div>
            </template>
            <template v-slot:cell(actions)="row">
              <b-dropdown
                size="sm"
                variant="link"
                toggle-class="text-decoration-none relation-actions-toggle"
                no-caret
                right
              >
                <template #button-content>
                  <i class="uil uil-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click="showReport(row.item)">Consultar</b-dropdown-item>
                <b-dropdown-item @click="editRegister(row.item)">Editar</b-dropdown-item>
                <b-dropdown-item @click="copyRegister(row.item)">Replicar</b-dropdown-item>
                <b-dropdown-item v-if="getBulaLink(row.item)" :href="getBulaLink(row.item)" target="_blank" rel="noopener noreferrer">
                  Ver bula
                </b-dropdown-item>
                <b-dropdown-item @click="modalDelete(row.item.id_item_produto)">Excluir</b-dropdown-item>
              </b-dropdown>
            </template>
            <template v-slot:cell(ativo)="row">{{
              row.item.ativo ? 'Sim' : 'Não'
            }}</template>
            <template #cell(id_produto)="row">
              <div class="relation-main-cell">
                <div class="relation-main-title">
                  {{ row.item.id_produto ? row.item.id_produto.nome : 'Não encontrado' }}
                </div>
                <div class="relation-main-meta">
                  <span>M.A.P.A {{ row.item.id_produto ? row.item.id_produto.mapa : '-' }}</span>
                  <span v-if="getBulaLink(row.item)">
                    <a
                      class="relation-inline-link"
                      :href="getBulaLink(row.item)"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Ver bula
                    </a>
                  </span>
                </div>
              </div>
            </template>
            <template #cell(id_cultura)="row">
              <div class="relation-main-cell">
                <div class="relation-main-title">
                  {{ row.item.id_cultura ? row.item.id_cultura.nome_comum : 'Não encontrado' }}
                </div>
                <div class="relation-main-meta">
                  <span>{{ row.item.id_cultura ? row.item.id_cultura.nome_cientifico : '-' }}</span>
                </div>
              </div>
            </template>
            <template #cell(id_pragas)="row">
              <div class="relation-main-cell">
                <div class="relation-main-title">
                  {{ row.item.id_pragas ? row.item.id_pragas.nome_comum : 'Não encontrado' }}
                </div>
                <div class="relation-main-meta">
                  <span>{{ row.item.id_pragas ? row.item.id_pragas.nome_cientifico : '-' }}</span>
                </div>
              </div>
            </template>
            <template #cell(id_tipo_aplicacao)="row">
              <div class="relation-main-cell">
                <div class="relation-main-title">
                  {{ row.item.id_tipo_aplicacao ? row.item.id_tipo_aplicacao.nome : 'Não encontrado' }}
                </div>
                <div class="relation-detail-grid">
                  <div class="relation-detail-item">
                    <span class="relation-detail-label">Dose</span>
                    <span class="relation-detail-value">
                      {{ row.item.dose_min || '-' }} a {{ row.item.dose_max || '-' }}
                      {{ row.item.id_unidade_aplic && row.item.id_unidade_aplic.unid1 ? row.item.id_unidade_aplic.unid1 : '' }}
                    </span>
                  </div>
                  <div class="relation-detail-item">
                    <span class="relation-detail-label">Local</span>
                    <span class="relation-detail-value">{{ getLocalAplicacaoLabel(row.item) }}</span>
                  </div>
                  <div class="relation-detail-item">
                    <span class="relation-detail-label">Estágio alvo</span>
                    <span class="relation-detail-value">{{ getEpocaAlvoLabel(row.item.id_epoca_praga) }}</span>
                  </div>
                  <div class="relation-detail-item">
                    <span class="relation-detail-label">Estágio cultura</span>
                    <span class="relation-detail-value">{{ getEpocaAlvoLabel(row.item.id_epoca_alvo) }}</span>
                  </div>
                  <div class="relation-detail-item">
                    <span class="relation-detail-label">Calda</span>
                    <span class="relation-detail-value">
                      {{ row.item.volume_calda_min || '-' }} a {{ row.item.volume_calda || '-' }}
                      {{ row.item.id_unidade && row.item.id_unidade.unid1 ? row.item.id_unidade.unid1 : '' }}
                    </span>
                  </div>
                  <div class="relation-detail-item">
                    <span class="relation-detail-label">Aplicações</span>
                    <span class="relation-detail-value">
                      {{ row.item.numero_aplicacoes_min || '-' }} a {{ row.item.numero_aplicacoes_max || '-' }} | Int. {{ row.item.intervalo_seguranca || '-' }}
                    </span>
                  </div>
                </div>
              </div>
            </template>
          </b-table>
          <b-pagination v-model="currentPage" size="md" :total-rows="rows" :per-page="perPage"></b-pagination>
        </div>
      </div>

      <div class="borda"></div>
    </div>
    <b-modal id="modal-delete" title="Aviso" title-class="font-18">
      <p>Tem certeza que deseja excluir este registro?</p>
      <div class="row">
        <div class="col-12">
          <b-form-group id="input-group-3" label="Desc. dose" label-for="input-3">
            <span>{{ this.itemProdutoReport.desc_dose }}</span>
          </b-form-group>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="$bvModal.hide('modal-delete')">Não</b-button>
        <b-button variant="danger" @click="Deletar">Sim</b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="showProdutoCadastroModal"
      title="Cadastrar Produto"
      title-class="font-18"
      size="xl"
      hide-footer
      @hidden="handleCadastroRelacionamentoHidden"
    >
      <formProduto :produto="produtoCadastroModal" />
    </b-modal>

    <b-modal
      id="modal-import-produto-relacao"
      v-model="showProdutoImportModal"
      title="Adicionar novo produto"
      title-class="font-18"
      size="md"
      centered
      :ok-title="importLoading ? 'Importando...' : 'Importar'"
      :ok-disabled="importLoading || !numeroRegistroInput"
      @ok.prevent="confirmarImportProduto"
      @hidden="numeroRegistroInput = ''; lastImportResponse = null"
    >
      <b-form-group
        label="Número de registro (MAPA)"
        description="Ex.: 2923 (será convertido para 02923 automaticamente)"
      >
        <b-form-input
          v-model="numeroRegistroInput"
          :disabled="importLoading"
          autocomplete="off"
        />
      </b-form-group>

      <b-alert
        v-if="lastImportResponse && (lastImportResponse.message || lastImportResponse.msg)"
        show
        variant="info"
        class="mb-0"
      >
        {{ lastImportResponse.message || lastImportResponse.msg }}
      </b-alert>

      <template #modal-footer="{ cancel }">
        <b-button variant="light" @click="cancel()" :disabled="importLoading">Cancelar</b-button>
        <b-button variant="primary" @click="confirmarImportProduto()" :disabled="importLoading || !numeroRegistroInput">
          <b-spinner small v-if="importLoading" class="mr-1" /> {{ importLoading ? 'Importando...' : 'Importar' }}
        </b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="showCulturaCadastroModal"
      title="Cadastrar Cultura"
      title-class="font-18"
      size="lg"
      hide-footer
      @hidden="handleCadastroRelacionamentoHidden"
    >
      <formCultura :cultura="culturaCadastroModal" />
    </b-modal>

    <b-modal
      v-model="showPragaCadastroModal"
      title="Cadastrar Praga"
      title-class="font-18"
      size="lg"
      hide-footer
      @hidden="handleCadastroRelacionamentoHidden"
    >
      <formPraga :praga="pragaCadastroModal" />
    </b-modal>

    <b-modal
      v-model="showImportBulaModal"
      title="Importar Dados da Bula"
      title-class="font-18"
      size="lg"
      content-class="import-bula-modal-content"
      @hidden="resetBulaImportModal"
      hide-footer
    >
      <div class="import-bula-modal">
        <div class="import-bula-intro">
          Envie a bula em PDF ou uma imagem/recorte. Se a API retornar relações extraídas, elas serão abertas direto no editor em tabela para revisão e salvamento.
        </div>

        <div class="row">
          <div class="col-md-6">
            <b-form-group label="Produto de referência">
              <v-select
                class="style-select"
                label="nome"
                :options="produtos"
                :reduce="(item) => item.id_produto"
                v-model="bulaImportForm.id_produto"
                @input="handleBulaImportProdutoChange"
              ></v-select>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group label="Arquivo da bula">
              <b-form-file
                :value="bulaImportForm.arquivo"
                accept=".pdf,image/*"
                browse-text="Selecionar"
                placeholder="Selecione PDF ou imagem"
                drop-placeholder="Solte o arquivo aqui"
                @input="handleBulaFileChange"
              ></b-form-file>
            </b-form-group>
          </div>
        </div>

        <div v-if="bulaImportForm.id_produto" class="import-bula-agrofit-card">
          <div class="import-bula-agrofit-head">
            <div>
              <div class="import-bula-agrofit-title">Culturas do Agrofit</div>
              <div class="import-bula-agrofit-subtitle">
                Selecione as culturas que devem ser priorizadas no prompt de extração.
              </div>
            </div>
            <button
              v-if="bulaImportCulturasOptions.length"
              type="button"
              class="import-bula-chip-btn"
              @click.prevent="toggleAllBulaCulturas(bulaImportSelectedCulturas.length !== bulaImportCulturasOptions.length)"
            >
              {{ bulaImportSelectedCulturas.length === bulaImportCulturasOptions.length ? 'Limpar seleção' : 'Selecionar todas' }}
            </button>
          </div>

          <div v-if="bulaImportCulturasLoading" class="import-bula-agrofit-state">
            Carregando culturas do Agrofit...
          </div>
          <div v-else-if="bulaImportCulturasOptions.length" class="import-bula-culture-grid">
            <label
              v-for="cultura in bulaImportCulturasOptions"
              :key="cultura.value"
              class="import-bula-culture-option"
            >
              <input
                :checked="bulaImportSelectedCulturas.includes(cultura.value)"
                type="checkbox"
                @change="toggleSelectedArrayValue('bulaImportSelectedCulturas', cultura.value, $event.target.checked)"
              >
              <span class="import-bula-culture-copy">
                <span class="import-bula-culture-name">{{ cultura.text }}</span>
                <span v-if="cultura.alvos.length" class="import-bula-culture-meta">
                  {{ cultura.alvos.slice(0, 3).join(', ') }}<span v-if="cultura.alvos.length > 3">...</span>
                </span>
              </span>
            </label>
          </div>
          <div v-else class="import-bula-agrofit-state">
            Nenhuma cultura do Agrofit foi encontrada para esse produto de referência.
          </div>
        </div>

        <b-form-group>
          <template #label>
            <div class="import-bula-label-row">
              <span>Observações para a extração</span>
              <button type="button" class="import-bula-prompt-btn" @click.prevent="applySuggestedBulaPrompt">
                Usar prompt sugerido
              </button>
            </div>
          </template>
          <b-form-textarea
            v-model="bulaImportForm.observacoes"
            rows="3"
            max-rows="8"
            placeholder="Ex.: considerar somente a seção da cultura soja, priorizar dose e volume de calda, ignorar itens de outras culturas."
          ></b-form-textarea>
        </b-form-group>

        <div v-if="bulaImportPreviewName" class="import-bula-preview">
          <div class="import-bula-preview-meta">
            <div class="import-bula-preview-label">Arquivo selecionado</div>
            <div class="import-bula-preview-name">{{ bulaImportPreviewName }}</div>
            <div v-if="bulaImportSourceUrl" class="import-bula-preview-source">
              Origem Agrofit vinculada ao envio
            </div>
          </div>
          <img
            v-if="bulaImportPreviewUrl"
            :src="bulaImportPreviewUrl"
            alt="Pré-visualização da bula"
            class="import-bula-preview-image"
          />
          <div v-else class="import-bula-preview-placeholder">
            PDF pronto para envio
          </div>
        </div>
        <div v-else-if="bulaImportSourceUrl" class="import-bula-preview">
          <div class="import-bula-preview-meta">
            <div class="import-bula-preview-label">Bula vinculada</div>
            <div class="import-bula-preview-name">Link do Agrofit preparado para extração</div>
            <div class="import-bula-preview-source">
              O arquivo será enviado pela URL retornada no comparativo.
            </div>
          </div>
          <div class="import-bula-preview-placeholder">
            Bula do Agrofit vinculada
          </div>
        </div>

        <div class="import-bula-footer">
          <b-button variant="light" @click="showImportBulaModal = false">Cancelar</b-button>
          <b-button variant="primary" @click="importBulaContent">Extrair e abrir editor</b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      v-model="showComparativoCulturasModal"
      title="Comparativo de Culturas"
      title-class="font-18"
      size="lg"
      content-class="comparativo-culturas-modal-content"
      @hidden="resetComparativoCulturasModal"
      hide-footer
    >
      <div class="comparativo-culturas-modal">
        <div class="comparativo-culturas-intro">
          Compare rapidamente as culturas existentes no Agrofit com o que já está cadastrado no WebReceita para o mesmo número MAPA.
        </div>

        <b-form-group label="Produto de referência">
          <v-select
            class="style-select"
            label="nome"
            :options="produtos"
            :reduce="(item) => item.id_produto"
            v-model="comparativoCulturasForm.id_produto"
            @input="handleComparativoProdutoChange"
          ></v-select>
        </b-form-group>

        <div v-if="comparativoCulturasLoading" class="comparativo-culturas-state">
          Carregando comparativo de culturas...
        </div>

        <div v-else-if="comparativoCulturasData" class="comparativo-culturas-grid">
          <div class="comparativo-culturas-summary">
            <div class="comparativo-summary-card">
              <span class="comparativo-summary-label">Produto Agrofit</span>
              <span class="comparativo-summary-value">
                {{ normalizeComparativoProduct(comparativoCulturasData.produto_agrofit).title }}
              </span>
              <span
                v-for="meta in normalizeComparativoProduct(comparativoCulturasData.produto_agrofit).meta"
                :key="`agrofit-meta-${meta}`"
                class="comparativo-summary-meta"
              >
                {{ meta }}
              </span>
            </div>
            <div class="comparativo-summary-card">
              <span class="comparativo-summary-label">Produto WebReceita</span>
              <span class="comparativo-summary-value">
                {{ normalizeComparativoProduct(comparativoCulturasData.produto_webreceita, getProdutoLabel(comparativoCulturasForm.id_produto)).title }}
              </span>
              <span
                v-for="meta in normalizeComparativoProduct(comparativoCulturasData.produto_webreceita, getProdutoLabel(comparativoCulturasForm.id_produto)).meta"
                :key="`webreceita-meta-${meta}`"
                class="comparativo-summary-meta"
              >
                {{ meta }}
              </span>
            </div>
          </div>

          <div class="comparativo-count-strip">
            <span class="comparativo-count-pill">
              Agrofit: {{ (comparativoCulturasData.culturas_agrofit || []).length }}
            </span>
            <span class="comparativo-count-pill">
              WebReceita: {{ (comparativoCulturasData.culturas_webreceita || []).length }}
            </span>
            <span class="comparativo-count-pill comparativo-count-pill-highlight">
              Faltantes: {{ (comparativoCulturasData.culturas_faltantes_no_webreceita || []).length }}
            </span>
            <span class="comparativo-count-pill">
              Em comum: {{ (comparativoCulturasData.culturas_em_comum || []).length }}
            </span>
          </div>

          <div class="comparativo-list-grid">
            <div class="comparativo-list-card">
              <div class="comparativo-list-title">Culturas no Agrofit</div>
              <ul class="comparativo-list">
                <li
                  v-for="cultura in comparativoCulturasData.culturas_agrofit || []"
                  :key="getComparativoCultureKey(cultura, 'agrofit')"
                  class="comparativo-list-item"
                >
                  <span class="comparativo-list-item-title">{{ normalizeComparativoCultureEntry(cultura).title }}</span>
                  <span
                    v-for="meta in normalizeComparativoCultureEntry(cultura).meta"
                    :key="`agrofit-item-meta-${meta}`"
                    class="comparativo-list-item-meta"
                  >
                    {{ meta }}
                  </span>
                </li>
                <li v-if="!(comparativoCulturasData.culturas_agrofit || []).length" class="comparativo-list-empty">Nenhuma cultura retornada.</li>
              </ul>
            </div>
            <div class="comparativo-list-card">
              <div class="comparativo-list-title">Culturas no WebReceita</div>
              <ul class="comparativo-list">
                <li
                  v-for="cultura in comparativoCulturasData.culturas_webreceita || []"
                  :key="getComparativoCultureKey(cultura, 'webreceita')"
                  class="comparativo-list-item"
                >
                  <span class="comparativo-list-item-title">{{ normalizeComparativoCultureEntry(cultura).title }}</span>
                  <span
                    v-for="meta in normalizeComparativoCultureEntry(cultura).meta"
                    :key="`webreceita-item-meta-${meta}`"
                    class="comparativo-list-item-meta"
                  >
                    {{ meta }}
                  </span>
                </li>
                <li v-if="!(comparativoCulturasData.culturas_webreceita || []).length" class="comparativo-list-empty">Nenhuma cultura cadastrada.</li>
              </ul>
            </div>
            <div class="comparativo-list-card comparativo-list-card-highlight">
              <div class="comparativo-list-card-head">
                <div class="comparativo-list-title">Faltantes no WebReceita</div>
                <button
                  type="button"
                  class="comparativo-action-btn"
                  :disabled="!comparativoSelectedMissingCulturas.length"
                  @click.prevent="openMissingCultureCadastro()"
                >
                  Abrir no importador
                </button>
              </div>
              <ul class="comparativo-list">
                <li
                  v-for="cultura in comparativoCulturasData.culturas_faltantes_no_webreceita || []"
                  :key="getComparativoCultureKey(cultura, 'faltante')"
                  class="comparativo-list-item comparativo-list-item-highlight"
                >
                  <label class="comparativo-select-item">
                    <input
                      :checked="comparativoSelectedMissingCulturas.includes(getComparativoMissingSelectionValue(cultura))"
                      type="checkbox"
                      @change="toggleSelectedArrayValue('comparativoSelectedMissingCulturas', getComparativoMissingSelectionValue(cultura), $event.target.checked)"
                    >
                    <span class="comparativo-select-copy">
                      <span class="comparativo-list-item-title">{{ normalizeComparativoCultureEntry(cultura).title }}</span>
                      <span
                        v-for="meta in normalizeComparativoCultureEntry(cultura).meta"
                        :key="`faltante-item-meta-${meta}`"
                        class="comparativo-list-item-meta"
                      >
                        {{ meta }}
                      </span>
                    </span>
                  </label>
                  <button
                    type="button"
                    class="comparativo-inline-link"
                    @click.prevent="openMissingCultureCadastro({
                      title: normalizeComparativoCultureEntry(cultura).title,
                      scientific: cultura && typeof cultura === 'object' ? (cultura.nome_cientifico || '') : ''
                    })"
                  >
                    Importar relação
                  </button>
                </li>
                <li v-if="!(comparativoCulturasData.culturas_faltantes_no_webreceita || []).length" class="comparativo-list-empty">Nenhuma cultura faltante.</li>
              </ul>
            </div>
            <div class="comparativo-list-card">
              <div class="comparativo-list-title">Culturas em comum</div>
              <ul class="comparativo-list">
                <li
                  v-for="cultura in comparativoCulturasData.culturas_em_comum || []"
                  :key="getComparativoCultureKey(cultura, 'comum')"
                  class="comparativo-list-item"
                >
                  <span class="comparativo-list-item-title">{{ normalizeComparativoCultureEntry(cultura).title }}</span>
                  <span
                    v-for="meta in normalizeComparativoCultureEntry(cultura).meta"
                    :key="`comum-item-meta-${meta}`"
                    class="comparativo-list-item-meta"
                  >
                    {{ meta }}
                  </span>
                </li>
                <li v-if="!(comparativoCulturasData.culturas_em_comum || []).length" class="comparativo-list-empty">Sem culturas em comum.</li>
              </ul>
            </div>
          </div>
        </div>

        <div v-else class="comparativo-culturas-state">
          Selecione um produto para consultar o comparativo.
        </div>

        <div class="comparativo-culturas-footer">
          <b-button variant="light" @click="showComparativoCulturasModal = false">Fechar</b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modal-bulk-edit-items"
      title="Editar Itens Selecionados"
      title-class="font-18"
      size="xl"
      dialog-class="bulk-edit-modal-shell"
      content-class="bulk-edit-modal-content"
      @hidden="resetBulkEditModal"
      hide-footer
    >
      <div class="bulk-edit-toolbar">
        <div class="bulk-edit-count">
          {{ bulkEditRows.length }} item(ns) selecionado(s)
          <span class="bulk-edit-hint">Use Tab para navegar entre os campos.</span>
        </div>
        <div class="bulk-edit-toolbar-actions">
          <div class="bulk-edit-replicate-panel">
            <span class="bulk-edit-replicate-label">Célula ativa</span>
            <span class="bulk-edit-replicate-value">
              {{ bulkEditActiveCell ? getBulkFieldLabel(bulkEditActiveCell.field) : 'Selecione uma célula' }}
            </span>
            <button
              class="btn btn-webreceita btn-sm"
              :disabled="!canReplicateActiveField"
              @click.prevent="replicateActiveBulkField"
            >
              Replicar valor
            </button>
          </div>
          <button class="btn btn-webreceita btn-sm" @click.prevent="addBulkEditRow">
            Adicionar linha
          </button>
        </div>
      </div>
      <div class="bulk-edit-table-wrapper">
        <table class="table table-bordered bulk-edit-table">
          <colgroup>
            <col class="bulk-col-product">
            <col class="bulk-col-cultura">
            <col class="bulk-col-alvo">
            <col class="bulk-col-tipo">
            <col class="bulk-col-number-wide">
            <col class="bulk-col-number-wide">
            <col class="bulk-col-select">
            <col class="bulk-col-number-wide">
            <col class="bulk-col-number-wide">
            <col class="bulk-col-select">
            <col class="bulk-col-number-wide">
            <col class="bulk-col-number-wide">
            <col class="bulk-col-number">
            <col class="bulk-col-local">
            <col class="bulk-col-epoca">
            <col class="bulk-col-epoca">
            <col class="bulk-col-description">
            <col class="bulk-col-actions">
          </colgroup>
          <thead>
            <tr>
              <th><span class="bulk-head-text">Produto</span></th>
              <th><span class="bulk-head-text">Cultura</span></th>
              <th><span class="bulk-head-text">Alvo</span></th>
              <th><span class="bulk-head-text">Tipo</span></th>
              <th><span class="bulk-head-text">Dose<br>Min</span></th>
              <th><span class="bulk-head-text">Dose<br>Max</span></th>
              <th><span class="bulk-head-text">Unid.<br>Dose</span></th>
              <th><span class="bulk-head-text">Calda<br>Min</span></th>
              <th><span class="bulk-head-text">Calda<br>Max</span></th>
              <th><span class="bulk-head-text">Unid.<br>Calda</span></th>
              <th><span class="bulk-head-text">Aplic.<br>Min</span></th>
              <th><span class="bulk-head-text">Aplic.<br>Max</span></th>
              <th><span class="bulk-head-text">Intervalo</span></th>
              <th><span class="bulk-head-text">Local</span></th>
              <th><span class="bulk-head-text">Estágio<br>Alvo</span></th>
              <th><span class="bulk-head-text">Estágio<br>Cultura</span></th>
              <th><span class="bulk-head-text">Desc. Modo<br>Aplicação</span></th>
              <th><span class="bulk-head-text">Ações</span></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="row in bulkEditRows"
              :key="row.bulk_row_key"
              :class="{ 'bulk-edit-active-row': bulkEditActiveCell && bulkEditActiveCell.rowId === row.bulk_row_key }"
            >
              <td
                class="bulk-edit-cell bulk-edit-context-cell"
                :class="{ 'bulk-edit-active-cell': isBulkCellEditing(row.bulk_row_key, 'id_produto') }"
                @focusin="setBulkActiveCell(row.bulk_row_key, 'id_produto')"
                @click="setBulkActiveCell(row.bulk_row_key, 'id_produto')"
              >
                <v-select
                  class="style-select bulk-edit-select"
                  label="nome"
                  :options="produtos"
                  :reduce="(item) => item.id_produto"
                  v-model="row.id_produto"
                  :clearable="false"
                ></v-select>
              </td>
              <td
                class="bulk-edit-cell bulk-edit-context-cell"
                :class="{ 'bulk-edit-active-cell': isBulkCellEditing(row.bulk_row_key, 'id_cultura') }"
                @focusin="setBulkActiveCell(row.bulk_row_key, 'id_cultura')"
                @click="setBulkActiveCell(row.bulk_row_key, 'id_cultura')"
              >
                <v-select
                  class="style-select bulk-edit-select"
                  label="nome_comum"
                  :options="culturas"
                  :reduce="(item) => item.id_cultura"
                  v-model="row.id_cultura"
                  :clearable="false"
                ></v-select>
              </td>
              <td
                class="bulk-edit-cell bulk-edit-context-cell"
                :class="{ 'bulk-edit-active-cell': isBulkCellEditing(row.bulk_row_key, 'id_pragas') }"
                @focusin="setBulkActiveCell(row.bulk_row_key, 'id_pragas')"
                @click="setBulkActiveCell(row.bulk_row_key, 'id_pragas')"
              >
                <v-select
                  class="style-select bulk-edit-select bulk-edit-select-rich"
                  label="nome_comum"
                  :options="pragas"
                  :reduce="(item) => item.id_pragas"
                  v-model="row.id_pragas"
                  :clearable="false"
                >
                  <template #option="item">
                    <div class="select-rich-option">
                      <span class="select-rich-title">{{ item.nome_comum }}</span>
                      <span v-if="item.nome_cientifico" class="select-rich-subtitle">{{ item.nome_cientifico }}</span>
                    </div>
                  </template>
                  <template #selected-option="item">
                    <div class="select-rich-option select-rich-option-selected">
                      <span class="select-rich-title">{{ item.nome_comum }}</span>
                      <span v-if="item.nome_cientifico" class="select-rich-subtitle">{{ item.nome_cientifico }}</span>
                    </div>
                  </template>
                </v-select>
              </td>
              <td
                class="bulk-edit-cell bulk-edit-context-cell"
                :class="{ 'bulk-edit-active-cell': isBulkCellEditing(row.bulk_row_key, 'id_tipo_aplicacao') }"
                @focusin="setBulkActiveCell(row.bulk_row_key, 'id_tipo_aplicacao')"
                @click="setBulkActiveCell(row.bulk_row_key, 'id_tipo_aplicacao')"
              >
                <v-select
                  class="style-select bulk-edit-select"
                  label="nome"
                  :options="tiposAplicacao"
                  :reduce="(item) => item.id_tipo_aplicacao"
                  v-model="row.id_tipo_aplicacao"
                  :clearable="false"
                ></v-select>
              </td>
              <td
                class="bulk-edit-cell bulk-edit-number-cell"
                :class="{ 'bulk-edit-active-cell': isBulkCellEditing(row.bulk_row_key, 'dose_min') }"
                @focusin="setBulkActiveCell(row.bulk_row_key, 'dose_min')"
                @click="setBulkActiveCell(row.bulk_row_key, 'dose_min')"
              >
                <b-form-input
                  v-model="row.dose_min"
                  type="number"
                  size="sm"
                ></b-form-input>
              </td>
              <td
                class="bulk-edit-cell bulk-edit-number-cell"
                :class="{ 'bulk-edit-active-cell': isBulkCellEditing(row.bulk_row_key, 'dose_max') }"
                @focusin="setBulkActiveCell(row.bulk_row_key, 'dose_max')"
                @click="setBulkActiveCell(row.bulk_row_key, 'dose_max')"
              >
                <b-form-input
                  v-model="row.dose_max"
                  type="number"
                  size="sm"
                ></b-form-input>
              </td>
              <td
                class="bulk-edit-cell bulk-edit-number-cell"
                :class="{ 'bulk-edit-active-cell': isBulkCellEditing(row.bulk_row_key, 'id_unidade_aplic') }"
                @focusin="setBulkActiveCell(row.bulk_row_key, 'id_unidade_aplic')"
                @click="setBulkActiveCell(row.bulk_row_key, 'id_unidade_aplic')"
              >
                <v-select
                  class="style-select bulk-edit-select"
                  label="unid1"
                  :options="unidades"
                  :reduce="(item) => item.id_unidade"
                  v-model="row.id_unidade_aplic"
                  :clearable="false"
                ></v-select>
              </td>
              <td
                class="bulk-edit-cell bulk-edit-number-cell"
                :class="{ 'bulk-edit-active-cell': isBulkCellEditing(row.bulk_row_key, 'volume_calda_min') }"
                @focusin="setBulkActiveCell(row.bulk_row_key, 'volume_calda_min')"
                @click="setBulkActiveCell(row.bulk_row_key, 'volume_calda_min')"
              >
                <b-form-input
                  v-model="row.volume_calda_min"
                  type="number"
                  size="sm"
                ></b-form-input>
              </td>
              <td
                class="bulk-edit-cell bulk-edit-number-cell"
                :class="{ 'bulk-edit-active-cell': isBulkCellEditing(row.bulk_row_key, 'volume_calda') }"
                @focusin="setBulkActiveCell(row.bulk_row_key, 'volume_calda')"
                @click="setBulkActiveCell(row.bulk_row_key, 'volume_calda')"
              >
                <b-form-input
                  v-model="row.volume_calda"
                  type="number"
                  size="sm"
                ></b-form-input>
              </td>
              <td
                class="bulk-edit-cell bulk-edit-number-cell"
                :class="{ 'bulk-edit-active-cell': isBulkCellEditing(row.bulk_row_key, 'id_unidade') }"
                @focusin="setBulkActiveCell(row.bulk_row_key, 'id_unidade')"
                @click="setBulkActiveCell(row.bulk_row_key, 'id_unidade')"
              >
                <v-select
                  class="style-select bulk-edit-select"
                  label="unid1"
                  :options="unidades"
                  :reduce="(item) => item.id_unidade"
                  v-model="row.id_unidade"
                  :clearable="false"
                ></v-select>
              </td>
              <td
                class="bulk-edit-cell bulk-edit-number-cell"
                :class="{ 'bulk-edit-active-cell': isBulkCellEditing(row.bulk_row_key, 'numero_aplicacoes_min') }"
                @focusin="setBulkActiveCell(row.bulk_row_key, 'numero_aplicacoes_min')"
                @click="setBulkActiveCell(row.bulk_row_key, 'numero_aplicacoes_min')"
              >
                <b-form-input
                  v-model="row.numero_aplicacoes_min"
                  type="number"
                  size="sm"
                ></b-form-input>
              </td>
              <td
                class="bulk-edit-cell bulk-edit-number-cell"
                :class="{ 'bulk-edit-active-cell': isBulkCellEditing(row.bulk_row_key, 'numero_aplicacoes_max') }"
                @focusin="setBulkActiveCell(row.bulk_row_key, 'numero_aplicacoes_max')"
                @click="setBulkActiveCell(row.bulk_row_key, 'numero_aplicacoes_max')"
              >
                <b-form-input
                  v-model="row.numero_aplicacoes_max"
                  type="number"
                  size="sm"
                ></b-form-input>
              </td>
              <td
                class="bulk-edit-cell bulk-edit-number-cell"
                :class="{ 'bulk-edit-active-cell': isBulkCellEditing(row.bulk_row_key, 'intervalo_seguranca') }"
                @focusin="setBulkActiveCell(row.bulk_row_key, 'intervalo_seguranca')"
                @click="setBulkActiveCell(row.bulk_row_key, 'intervalo_seguranca')"
              >
                <b-form-input
                  v-model="row.intervalo_seguranca"
                  type="number"
                  size="sm"
                ></b-form-input>
              </td>
              <td
                class="bulk-edit-cell bulk-edit-context-cell"
                :class="{ 'bulk-edit-active-cell': isBulkCellEditing(row.bulk_row_key, 'id_local_aplicacao') }"
                @focusin="setBulkActiveCell(row.bulk_row_key, 'id_local_aplicacao')"
                @click="setBulkActiveCell(row.bulk_row_key, 'id_local_aplicacao')"
              >
                <v-select
                  class="style-select bulk-edit-select"
                  label="nome"
                  :options="locaisAplicacao"
                  :reduce="(item) => item.id_local_aplicacao"
                  v-model="row.id_local_aplicacao"
                  :clearable="false"
                ></v-select>
              </td>
              <td
                class="bulk-edit-cell bulk-edit-context-cell"
                :class="{ 'bulk-edit-active-cell': isBulkCellEditing(row.bulk_row_key, 'id_epoca_praga') }"
                @focusin="setBulkActiveCell(row.bulk_row_key, 'id_epoca_praga')"
                @click="setBulkActiveCell(row.bulk_row_key, 'id_epoca_praga')"
              >
                <v-select
                  class="style-select bulk-edit-select"
                  label="descricao"
                  :options="epocasAlvo"
                  :reduce="(item) => item.id_epoca_alvo"
                  v-model="row.id_epoca_praga"
                  :clearable="false"
                ></v-select>
              </td>
              <td
                class="bulk-edit-cell bulk-edit-context-cell"
                :class="{ 'bulk-edit-active-cell': isBulkCellEditing(row.bulk_row_key, 'id_epoca_alvo') }"
                @focusin="setBulkActiveCell(row.bulk_row_key, 'id_epoca_alvo')"
                @click="setBulkActiveCell(row.bulk_row_key, 'id_epoca_alvo')"
              >
                <v-select
                  class="style-select bulk-edit-select"
                  label="descricao"
                  :options="epocasAlvo"
                  :reduce="(item) => item.id_epoca_alvo"
                  v-model="row.id_epoca_alvo"
                  :clearable="false"
                ></v-select>
              </td>
              <td
                class="bulk-edit-cell bulk-edit-description-cell"
                :class="{ 'bulk-edit-active-cell': isBulkCellEditing(row.bulk_row_key, 'desc_modo_aplicacao') }"
                @focusin="setBulkActiveCell(row.bulk_row_key, 'desc_modo_aplicacao')"
                @click="setBulkActiveCell(row.bulk_row_key, 'desc_modo_aplicacao')"
              >
                <div class="bulk-edit-description-field">
                  <b-form-textarea
                    v-model="row.desc_modo_aplicacao"
                    rows="3"
                    max-rows="5"
                  ></b-form-textarea>
                </div>
              </td>
              <td class="bulk-edit-actions-cell">
                <div class="bulk-edit-actions-panel">
                  <button
                    type="button"
                    class="bulk-edit-icon-btn bulk-edit-icon-btn-copy"
                    @click.prevent="copyBulkEditRow(row)"
                    title="Copiar linha"
                    aria-label="Copiar linha"
                  >
                    <i class="uil uil-copy"></i>
                  </button>
                  <button
                    type="button"
                    class="bulk-edit-icon-btn bulk-edit-icon-btn-danger"
                    @click.prevent="removeBulkEditRow(row.bulk_row_key)"
                    title="Remover linha"
                    aria-label="Remover linha"
                  >
                    <i class="uil uil-trash-alt"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="bulk-edit-footer">
        <b-button variant="light" @click="$bvModal.hide('modal-bulk-edit-items')">Cancelar</b-button>
        <b-button variant="primary" @click="saveBulkEditRows">Salvar alterações</b-button>
      </div>
    </b-modal>

    <b-modal v-if="this.itemProdutoReport.id_produto != null" size="lg" id="modal-report" title="Resumo da Relação"
      title-class="font-18">
      <div class="row">
        <div class="col-4">
          <b-form-group id="input-group-3" label="Produto" label-for="input-3">
            <span>{{ this.itemProdutoReport.id_produto.nome }}</span>
          </b-form-group>
        </div>
        <div class="col-4">
          <b-form-group id="input-group-3" label="Cultura" label-for="input-3">
            <span>{{ this.itemProdutoReport.id_cultura.nome_comum }}</span>
          </b-form-group>
        </div>
        <div class="col-4">
          <b-form-group id="input-group-3" label="Alvo" label-for="input-3">
            <span>{{ this.itemProdutoReport.id_pragas.nome_comum }}</span>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <b-form-group id="input-group-3" label="Dose mínima" label-for="input-3">
            <span>{{ this.itemProdutoReport.dose_min }}</span>
          </b-form-group>
        </div>
        <div class="col-4">
          <b-form-group id="input-group-3" label="Dose máxima" label-for="input-3">
            <span>{{ this.itemProdutoReport.dose_max }}</span>
          </b-form-group>
        </div>
        <div class="col-4">
          <b-form-group id="input-group-3" label="Volume de calda" label-for="input-3">
            <span>{{ this.itemProdutoReport.volume_calda }}</span>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <b-form-group id="input-group-3" label="Aplicação mínima" label-for="input-3">
            <span>{{ this.itemProdutoReport.numero_aplicacoes_min }}</span>
          </b-form-group>
        </div>
        <div class="col-4">
          <b-form-group id="input-group-3" label="Aplicação máxima" label-for="input-3">
            <span>{{ this.itemProdutoReport.numero_aplicacoes_max }}</span>
          </b-form-group>
        </div>
        <div class="col-4">
          <b-form-group id="input-group-3" label="Intervalo de segurança" label-for="input-3">
            <span>{{ this.itemProdutoReport.intervalo_seguranca }}</span>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <b-form-group id="input-group-3" label="Desc. dose" label-for="input-3">
            <span>{{ this.itemProdutoReport.desc_dose }}</span>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <b-form-group id="input-group-3" label="Desc. Modo de aplicação" label-for="input-3">
            <span>{{ this.itemProdutoReport.desc_modo_aplicacao }}</span>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <b-form-group id="input-group-3" label="Desc. Volume Calda" label-for="input-3">
            <span>{{ this.itemProdutoReport.desc_volume_calda }}</span>
          </b-form-group>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="$bvModal.hide('modal-report')">Ok</b-button>
      </template>
    </b-modal>

    <b-modal size="xl" id="modal-create-equipament" title="Adicionar Equipamentos de Aplicação" title-class="font-18">
      <div class="row">
        <b-form-select v-model="selectedCulture" multiple :select-size="4">
          <b-form-select-option :value="null">Todos</b-form-select-option>
          <b-form-select-option v-for="culture in cultures" :key="culture.value" :value="culture.value">
            {{ culture.value }}
          </b-form-select-option>
        </b-form-select>

        <div class="col-12">
          <b-table striped hover :fields="equipamentosItemProdutoFields" :items="filteredItems">
            <template #cell(nomeProduto)="row">{{
              row.item.nomeProduto
                ? row.item.nomeProduto
                : 'Não encontrado'
            }}
            </template>
            <template #cell(nomeCultura)="row">{{
              row.item.nomeCultura
                ? row.item.nomeCultura
                : 'Não encontrado'
            }}</template>
            <template #cell(nomePraga)="row">{{
              row.item.nomePraga
                ? row.item.nomePraga
                : 'Não encontrado'
            }}</template>

            <template #cell(tipoAplicacao)="row">{{
              row.item.tipoAplicacao
                ? row.item.tipoAplicacao
                : 'Não encontrado'
            }}</template>

            <template #cell(manual)="row">
              <b-form-checkbox v-model="row.item.manual" value="true" unchecked-value="false">
              </b-form-checkbox>
              <b-form-input v-if="row.item.manual === 'true'" v-model="row.item.manualCaldaMin" placeholder="Calda Min"
                class="mt-2"></b-form-input>
              <b-form-input v-if="row.item.manual === 'true'" v-model="row.item.manualCaldaMax" placeholder="Calda Max"
                class="mt-2"></b-form-input>
            </template>

            <template #cell(costal)="row">
              <b-form-checkbox v-model="row.item.costal" value="true" unchecked-value="false">
              </b-form-checkbox>
              <b-form-input v-if="row.item.costal === 'true'" v-model="row.item.costalCaldaMin" placeholder="Calda Min"
                class="mt-2"></b-form-input>
              <b-form-input v-if="row.item.costal === 'true'" v-model="row.item.costalCaldaMax" placeholder="Calda max"
                class="mt-2"></b-form-input>
            </template>

            <template #cell(tratorizado)="row">
              <b-form-checkbox v-model="row.item.tratorizado" value="true" unchecked-value="false">
              </b-form-checkbox>
              <b-form-input v-if="row.item.tratorizado === 'true'" v-model="row.item.tratorizadoCaldaMin"
                placeholder="Calda Min" class="mt-2"></b-form-input>
              <b-form-input v-if="row.item.tratorizado === 'true'" v-model="row.item.tratorizadoCaldaMax"
                placeholder="Calda Max" class="mt-2"></b-form-input>
            </template>

            <template #cell(tratorizado_barra)="row">
              <b-form-checkbox v-model="row.item.tratorizadoBarra" value="true" unchecked-value="false">
              </b-form-checkbox>
              <b-form-input v-if="row.item.tratorizadoBarra === 'true'" v-model="row.item.tratorizadoBarraCaldaMin"
                placeholder="Calda Min" class="mt-2"></b-form-input>
              <b-form-input v-if="row.item.tratorizadoBarra === 'true'" v-model="row.item.tratorizadoBarraCaldaMax"
                placeholder="Calda Max" class="mt-2"></b-form-input>
            </template>

            <template #cell(aerea)="row">
              <b-form-checkbox v-model="row.item.aerea" value="true" unchecked-value="false">
              </b-form-checkbox>
              <b-form-input v-if="row.item.aerea === 'true'" v-model="row.item.aereaCaldaMin" placeholder="Calda Min"
                class="mt-2"></b-form-input>
              <b-form-input v-if="row.item.aerea === 'true'" v-model="row.item.aereaCaldaMax" placeholder="Calda Max"
                class="mt-2"></b-form-input>
            </template>

            <template #cell(drone)="row">
              <b-form-checkbox v-model="row.item.drone" value="true" unchecked-value="false">
              </b-form-checkbox>
              <b-form-input v-if="row.item.drone === 'true'" v-model="row.item.droneCaldaMin" placeholder="Calda Min"
                class="mt-2"></b-form-input>
              <b-form-input v-if="row.item.drone === 'true'" v-model="row.item.droneCaldaMax" placeholder="Calda Max"
                class="mt-2"></b-form-input>

            </template>
          </b-table>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="$bvModal.hide('modal-create-equipament')">Não</b-button>
        <b-button variant="danger" @click="saveEquipamentos()">Sim</b-button>
      </template>
    </b-modal>

    <b-modal
      id="modal-replicate-item"
      size="xl"
      title="Replicar Relação"
      title-class="font-18"
      modal-class="replicate-modal-shell"
      content-class="replicate-modal-content"
      @hidden="resetReplicateModal"
      hide-footer
    >
      <div v-if="replicateBaseItem" class="replicate-modal">
        <div class="replicate-summary">
          <div class="replicate-summary-title">Base da replicação</div>
          <div class="replicate-summary-grid">
            <div class="replicate-summary-item">
              <span class="replicate-summary-label">Produto</span>
              <span class="replicate-summary-value">{{ replicateBaseItem.id_produto ? replicateBaseItem.id_produto.nome : '-' }}</span>
            </div>
            <div class="replicate-summary-item">
              <span class="replicate-summary-label">Cultura atual</span>
              <span class="replicate-summary-value">{{ replicateBaseItem.id_cultura ? replicateBaseItem.id_cultura.nome_comum : '-' }}</span>
            </div>
            <div class="replicate-summary-item">
              <span class="replicate-summary-label">Alvo</span>
              <span class="replicate-summary-value">{{ replicateBaseItem.id_pragas ? replicateBaseItem.id_pragas.nome_comum : '-' }}</span>
            </div>
            <div class="replicate-summary-item">
              <span class="replicate-summary-label">Tipo Aplicação</span>
              <span class="replicate-summary-value">{{ replicateBaseItem.id_tipo_aplicacao ? replicateBaseItem.id_tipo_aplicacao.nome : '-' }}</span>
            </div>
          </div>
        </div>

        <div class="replicate-toolbar">
          <div class="replicate-toolbar-title">Novas relações</div>
          <button class="btn btn-webreceita" @click.prevent="addReplicateRow">Adicionar linha</button>
        </div>

        <div class="replicate-table-wrapper">
          <table class="replicate-table">
            <thead>
              <tr>
                <th>Linha</th>
                <th>Cultura</th>
                <th>Alvo</th>
                <th>Tipo Aplicação</th>
                <th>Dose Min</th>
                <th>Dose Max</th>
                <th>Calda Min</th>
                <th>Calda Max</th>
                <th>Aplic. Min</th>
                <th>Aplic. Max</th>
                <th>Intervalo</th>
                <th>Ativo</th>
                <th>Mais</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(row, index) in replicateRows">
                <tr :key="`replicate-row-main-${index}`">
                  <td class="replicate-row-index">{{ index + 1 }}</td>
                <td class="replicate-select-cell">
                  <v-select class="style-select replicate-select" label="nome_comum" :options="culturas"
                    :reduce="(item) => item.id_cultura" v-model="row.id_cultura"></v-select>
                </td>
                <td class="replicate-select-cell">
                  <v-select class="style-select replicate-select style-select-rich" label="nome_comum" :options="pragas"
                    :reduce="(item) => item.id_pragas" v-model="row.id_pragas">
                    <template #option="item">
                      <div class="select-rich-option">
                        <span class="select-rich-title">{{ item.nome_comum }}</span>
                        <span v-if="item.nome_cientifico" class="select-rich-subtitle">{{ item.nome_cientifico }}</span>
                      </div>
                    </template>
                    <template #selected-option="item">
                      <div class="select-rich-option select-rich-option-selected">
                        <span class="select-rich-title">{{ item.nome_comum }}</span>
                        <span v-if="item.nome_cientifico" class="select-rich-subtitle">{{ item.nome_cientifico }}</span>
                      </div>
                    </template>
                  </v-select>
                </td>
                <td class="replicate-select-cell">
                  <v-select class="style-select replicate-select" label="nome" :options="tiposAplicacao"
                    :reduce="(item) => item.id_tipo_aplicacao" v-model="row.id_tipo_aplicacao"></v-select>
                </td>
                  <td><b-form-input v-model="row.dose_min" type="number" size="sm"></b-form-input></td>
                  <td><b-form-input v-model="row.dose_max" type="number" size="sm"></b-form-input></td>
                  <td><b-form-input v-model="row.volume_calda_min" type="number" size="sm"></b-form-input></td>
                  <td><b-form-input v-model="row.volume_calda" type="number" size="sm"></b-form-input></td>
                  <td><b-form-input v-model="row.numero_aplicacoes_min" type="number" size="sm"></b-form-input></td>
                  <td><b-form-input v-model="row.numero_aplicacoes_max" type="number" size="sm"></b-form-input></td>
                  <td><b-form-input v-model="row.intervalo_seguranca" type="number" size="sm"></b-form-input></td>
                  <td class="replicate-check-cell">
                    <b-form-checkbox v-model="row.ativo"></b-form-checkbox>
                  </td>
                  <td class="replicate-expand-cell">
                    <button class="btn btn-sm btn-outline-primary" @click.prevent="toggleReplicateDetails(index)">
                      {{ replicateExpandedRows[index] ? 'Ocultar' : 'Detalhes' }}
                    </button>
                  </td>
                  <td>
                    <div class="replicate-actions-cell">
                      <button class="btn btn-sm btn-outline-secondary" @click.prevent="duplicateReplicateRow(index)">Duplicar</button>
                      <button class="btn btn-sm btn-outline-danger" :disabled="replicateRows.length === 1" @click.prevent="removeReplicateRow(index)">Remover</button>
                    </div>
                  </td>
                </tr>
                <tr v-if="replicateExpandedRows[index]" :key="`replicate-row-details-${index}`" class="replicate-details-row">
                  <td colspan="14">
                    <div class="replicate-details-grid">
                      <div class="replicate-detail-field">
                        <label>Local</label>
                        <v-select class="style-select replicate-select" label="nome" :options="locaisAplicacao"
                          :reduce="(item) => item.id_local_aplicacao" v-model="row.id_local_aplicacao"></v-select>
                      </div>
                      <div class="replicate-detail-field">
                        <label>Unid. Dose</label>
                        <v-select class="style-select replicate-select" label="unid1" :options="unidades"
                          :reduce="(item) => item.id_unidade" v-model="row.id_unidade_aplic"></v-select>
                      </div>
                      <div class="replicate-detail-field">
                        <label>Unid. Calda</label>
                        <v-select class="style-select replicate-select" label="unid1" :options="unidades"
                          :reduce="(item) => item.id_unidade" v-model="row.id_unidade"></v-select>
                      </div>
                      <div class="replicate-detail-field">
                        <label>Estágio Alvo</label>
                        <v-select class="style-select replicate-select" label="descricao" :options="epocasAlvo"
                          :reduce="(item) => item.id_epoca_alvo" v-model="row.id_epoca_praga"></v-select>
                      </div>
                      <div class="replicate-detail-field">
                        <label>Estágio Cultura</label>
                        <v-select class="style-select replicate-select" label="descricao" :options="epocasAlvo"
                          :reduce="(item) => item.id_epoca_alvo" v-model="row.id_epoca_alvo"></v-select>
                      </div>
                      <div class="replicate-detail-field replicate-detail-text">
                        <label>Desc. Dose</label>
                        <b-form-textarea v-model="row.desc_dose" rows="2" max-rows="3"></b-form-textarea>
                      </div>
                      <div class="replicate-detail-field replicate-detail-text">
                        <label>Desc. Modo</label>
                        <b-form-textarea v-model="row.desc_modo_aplicacao" rows="2" max-rows="3"></b-form-textarea>
                      </div>
                      <div class="replicate-detail-field replicate-detail-text">
                        <label>Desc. Calda</label>
                        <b-form-textarea v-model="row.desc_volume_calda" rows="2" max-rows="3"></b-form-textarea>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>

        <div class="replicate-footer">
          <button class="btn btn-light mr-2" @click.prevent="$bvModal.hide('modal-replicate-item')">Cancelar</button>
          <button class="btn btn-webreceita" @click.prevent="saveReplicatedItems">Salvar replicações</button>
        </div>
      </div>
    </b-modal>

    <b-overlay :show="isLoading" no-wrap>
    </b-overlay>
  </Layout>
</template>
<style lang="scss">
.bloco {
  margin-top: 30px;
  background-color: #fff;
  padding: 40px;
  border-radius: 0.25rem;

  .titulo {
    font-size: 25px;
    color: #008e75;
    margin-bottom: 10px;
    font-weight: bold;
  }

  .subtitulo {
    margin-bottom: 10px;
  }

  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px #edeff4;
  }

  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .btn-webreceita {
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #008e75;
    padding: 5px 30px;

    &.botaoTopo {
      float: right;
    }
  }

  .bulk-edit-trigger {
    min-height: 38px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 0.5rem 0.9rem;
    border-radius: 10px;
    border: 1px solid #cfe3da;
    background: linear-gradient(180deg, #f7fbf9 0%, #edf6f2 100%);
    color: #1f5d50;
    font-weight: 700;
    transition: all 0.18s ease;
  }

  .bulk-edit-trigger:hover:not(:disabled) {
    border-color: #8fc6b3;
    background: linear-gradient(180deg, #eef8f4 0%, #e0f1eb 100%);
    color: #0f4f42;
    box-shadow: 0 10px 18px rgba(0, 142, 117, 0.08);
  }

  .bulk-edit-trigger:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    color: #8a9a95;
    background: #f5f7f6;
    border-color: #dde6e2;
    box-shadow: none;
  }

  .bulk-edit-trigger-count {
    min-width: 22px;
    height: 22px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0 6px;
    border-radius: 999px;
    background: #008e75;
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    line-height: 1;
  }

  .import-bula-trigger {
    min-height: 38px;
    margin-top: 0;
    border: 1px dashed #8fc6b3;
    border-radius: 10px;
    background: #ffffff;
    color: #0f5a4c;
    font-weight: 700;
    transition: all 0.18s ease;
  }

  .import-bula-trigger:hover {
    border-color: #53a892;
    background: #f3fbf8;
    color: #0c5c4d;
  }

  .filterButton {
    // margin-top: 5px;
    // margin-bottom: 10px;
    background-color: #008e74c7;
    padding: 0 20px;
  }

  .relation-helper-btn {
    margin-top: 8px;
    padding: 0;
    border: 0;
    background: transparent;
    color: #008e75;
    font-size: 12px;
    font-weight: 700;
    text-align: left;
    text-decoration: underline;
  }

  .relation-helper-btn:hover {
    color: #006f5c;
  }

  .relation-helper-btn-secondary {
    text-decoration: none;
    color: #0b5a4b;
  }

  .relation-helper-btn-secondary:hover {
    color: #08463b;
  }

  .inline-editor {
    padding: 22px;
    border: 1px solid #dfe7eb;
    border-radius: 16px;
    background: linear-gradient(180deg, #fcfefd 0%, #f5faf8 100%);
    box-shadow: 0 10px 24px rgba(8, 72, 55, 0.06);
  }

  .inline-editor-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    margin-bottom: 18px;
  }

  .inline-editor-title {
    font-size: 20px;
    font-weight: 700;
    color: #0c5c4d;
  }

  .inline-editor-subtitle {
    margin-top: 4px;
    color: #637b74;
    font-size: 13px;
  }

  .inline-editor-header-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 10px;
  }

  .inline-status {
    display: flex;
    align-items: center;
    min-height: 38px;
    padding: 0 12px;
    border: 1px solid #d5e5dd;
    border-radius: 999px;
    background: #ffffff;
  }

  .inline-editor-panel {
    height: 100%;
    margin-bottom: 16px;
    padding: 18px 18px 8px;
    border: 1px solid #e4ece8;
    border-radius: 14px;
    background: #ffffff;
  }

  .inline-editor-section-title {
    margin: 0 0 14px;
    font-size: 13px;
    font-weight: 700;
    color: #3c5b53;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }

  .inline-editor-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 8px;
  }

  .replicate-modal {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .replicate-summary {
    padding: 16px 18px;
    border: 1px solid #e2ebe7;
    border-radius: 14px;
    background: #f8fcfa;
  }

  .replicate-summary-title,
  .replicate-toolbar-title {
    font-size: 16px;
    font-weight: 700;
    color: #0c5c4d;
  }

  .replicate-summary-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 12px;
    margin-top: 14px;
  }

  .replicate-summary-item {
    padding: 12px;
    border: 1px solid #e6efea;
    border-radius: 12px;
    background: #ffffff;
  }

  .replicate-summary-label {
    display: block;
    margin-bottom: 4px;
    font-size: 11px;
    font-weight: 700;
    color: #6a8279;
    text-transform: uppercase;
  }

  .replicate-summary-value {
    color: #1f4037;
    font-weight: 600;
  }

  .replicate-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }

  .replicate-table-wrapper {
    overflow-x: auto;
    border: 1px solid #dfe8e3;
    border-radius: 14px;
    background: #ffffff;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.7);
  }

  .replicate-table {
    width: 100%;
    min-width: 2200px;
    border-collapse: separate;
    border-spacing: 0;
  }

  .replicate-table th,
  .replicate-table td {
    padding: 8px;
    border-bottom: 1px solid #edf2ef;
    vertical-align: top;
  }

  .replicate-table th {
    position: sticky;
    top: 0;
    z-index: 1;
    background: #f7fbf9;
    color: #47675e;
    font-size: 12px;
    font-weight: 700;
    white-space: nowrap;
    padding: 12px 8px;
  }

  .replicate-table tbody tr:nth-child(even) td {
    background: #fbfdfc;
  }

  .replicate-table tbody tr:hover td {
    background: #f4faf7;
  }

  .replicate-table tbody tr:last-child td {
    border-bottom: 0;
  }

  .replicate-row-index {
    font-weight: 700;
    color: #31574d;
    white-space: nowrap;
    min-width: 56px;
    text-align: center;
    padding-top: 16px;
  }

  .replicate-select {
    min-width: 180px;
  }

  .replicate-check-cell {
    min-width: 74px;
    text-align: center;
    padding-top: 18px !important;
  }

  .replicate-actions-cell {
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 110px;
  }

  .replicate-select-cell {
    min-width: 180px;
  }

  .replicate-text-cell {
    min-width: 220px;
  }

  .replicate-table .form-control {
    min-height: 36px;
    border-color: #d7e4de;
    box-shadow: none;
    font-size: 13px;
  }

  .replicate-table textarea.form-control {
    min-height: 66px;
    resize: vertical;
  }

  .replicate-table .vs__dropdown-toggle {
    min-height: 36px;
    border: 1px solid #d7e4de;
    border-radius: 0.25rem;
    background: #fff;
    padding: 2px 6px;
  }

  .replicate-table .vs__selected {
    font-size: 13px;
    color: #294840;
  }

  .replicate-table .vs__search,
  .replicate-table .vs__search::placeholder {
    font-size: 13px;
  }

  .replicate-table .vs--open .vs__dropdown-toggle,
  .replicate-table .form-control:focus {
    border-color: #7fb7a0;
    box-shadow: 0 0 0 0.12rem rgba(0, 142, 117, 0.12);
  }

  .replicate-actions-cell .btn {
    white-space: nowrap;
  }

  .replicate-footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding-top: 8px;
  }

  @media (max-width: 991px) {
    .inline-editor-header {
      flex-direction: column;
      align-items: stretch;
    }

    .inline-editor-header-actions {
      justify-content: flex-start;
    }

    .replicate-summary-grid {
      grid-template-columns: 1fr 1fr;
    }

    .replicate-toolbar,
    .replicate-footer {
      flex-direction: column;
      align-items: stretch;
    }
  }

  .cadastra {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .relation-main-cell {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
  }

  .relation-main-title {
    color: #243746;
    font-size: 14px;
    font-weight: 700;
    line-height: 1.3;
    word-break: normal;
  }

  .relation-main-meta {
    display: flex;
    flex-direction: column;
    gap: 2px;
    color: #6b7280;
    font-size: 12px;
    line-height: 1.2;
  }

  .relation-inline-link {
    color: #008e75;
    font-weight: 700;
    text-decoration: none;
  }

  .relation-inline-link:hover {
    text-decoration: underline;
  }

  .relation-detail-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 6px;
    margin-top: 4px;
  }

  .relation-detail-item {
    display: flex;
    gap: 6px;
    align-items: baseline;
    min-width: 0;
  }

  .relation-detail-label {
    flex: 0 0 auto;
    color: #6b7280;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
  }

  .relation-detail-value {
    min-width: 0;
    color: #4b5563;
    font-size: 12px;
    line-height: 1.25;
    word-break: normal;
  }

  .relation-select-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100%;
  }

  :deep(th.relation-col-select),
  :deep(td.relation-col-select) {
    text-align: center;
    vertical-align: middle;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  :deep(th.relation-col-select .custom-control),
  :deep(td.relation-col-select .custom-control),
  :deep(.relation-select-cell .custom-control) {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 24px;
    margin: 0;
    padding-left: 1rem;
  }

  :deep(th.relation-col-select .custom-control-label),
  :deep(td.relation-col-select .custom-control-label),
  :deep(.relation-select-cell .custom-control-label) {
    min-height: 16px;
  }

  :deep(table.b-table) {
    width: 100%;
    table-layout: fixed;
  }

  :deep(table.b-table thead th:nth-child(1)),
  :deep(table.b-table tbody td:nth-child(1)) {
    width: 4% !important;
    min-width: 48px !important;
  }

  :deep(table.b-table thead th:nth-child(2)),
  :deep(table.b-table tbody td:nth-child(2)) {
    width: 36% !important;
    min-width: 360px !important;
  }

  :deep(table.b-table thead th:nth-child(3)),
  :deep(table.b-table tbody td:nth-child(3)) {
    width: 13% !important;
    min-width: 170px !important;
  }

  :deep(table.b-table thead th:nth-child(4)),
  :deep(table.b-table tbody td:nth-child(4)) {
    width: 14% !important;
    min-width: 180px !important;
  }

  :deep(table.b-table thead th:nth-child(5)),
  :deep(table.b-table tbody td:nth-child(5)) {
    width: 27% !important;
    min-width: 290px !important;
  }

  :deep(table.b-table thead th:nth-child(6)),
  :deep(table.b-table tbody td:nth-child(6)) {
    width: 6% !important;
    min-width: 72px !important;
  }

  :deep(td.relation-col-product),
  :deep(td.relation-col-cultura),
  :deep(td.relation-col-alvo),
  :deep(td.relation-col-details) {
    padding-top: 12px;
    padding-bottom: 12px;
  }

  :deep(td.relation-col-actions) {
    text-align: center;
    vertical-align: middle;
  }

  :deep(.relation-actions-toggle) {
    color: #4b5563 !important;
    padding: 0.15rem 0.35rem !important;
    font-size: 18px;
  }

  :deep(.relation-actions-toggle:hover) {
    color: #008e75 !important;
  }

  .bulk-edit-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
  }

  .bulk-edit-count {
    font-size: 13px;
    font-weight: 700;
    color: #31574d;
  }

  .bulk-edit-hint {
    display: inline-block;
    margin-left: 8px;
    color: #6d857d;
    font-size: 12px;
    font-weight: 500;
  }

  .bulk-edit-table-wrapper {
    overflow-x: auto;
    border: 1px solid #dfe8e3;
    border-radius: 16px;
    background: #ffffff;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.72);
    max-height: 68vh;
  }

  .bulk-edit-table {
    min-width: 2460px;
    margin-bottom: 0;
    background: #fff;
    border-collapse: separate;
    border-spacing: 0;
  }

  .bulk-edit-table .bulk-col-product {
    width: 190px;
  }

  .bulk-edit-table .bulk-col-cultura {
    width: 140px;
  }

  .bulk-edit-table .bulk-col-alvo {
    width: 160px;
  }

  .bulk-edit-table .bulk-col-tipo {
    width: 180px;
  }

  .bulk-edit-table .bulk-col-number {
    width: 110px;
  }

  .bulk-edit-table .bulk-col-number-wide {
    width: 176px;
  }

  .bulk-edit-table .bulk-col-select {
    width: 145px;
  }

  .bulk-edit-table .bulk-col-local {
    width: 170px;
  }

  .bulk-edit-table .bulk-col-epoca {
    width: 190px;
  }

  .bulk-edit-table .bulk-col-description {
    width: 260px;
  }

  .bulk-edit-table thead th {
    position: sticky;
    top: 0;
    z-index: 3;
    background: #f1f7f4;
    color: #264a41;
    font-size: 12px;
    font-weight: 700;
    white-space: nowrap;
    letter-spacing: 0.02em;
    padding: 14px 12px;
    border-bottom: 1px solid #d7e4de;
    vertical-align: middle;
    text-align: center;
  }

  .bulk-head-text {
    display: inline-block;
    line-height: 1.25;
  }

  .bulk-edit-apply-row th {
    background: #e7f2ed !important;
    vertical-align: top;
    top: 48px;
    z-index: 2;
  }

  .bulk-edit-apply-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    min-width: 220px;
    color: #31574d;
    font-size: 13px;
    font-weight: 700;
  }

  .bulk-edit-table td {
    vertical-align: top;
    min-width: 120px;
    padding: 12px 10px;
    border-top: 0;
    border-bottom: 1px solid #eef3f0;
  }

  .bulk-edit-table tbody tr:nth-child(even) td {
    background: #fcfefd;
  }

  .bulk-edit-table tbody tr:hover td {
    background: #f4faf7;
  }

  .bulk-edit-table .form-control {
    min-height: 38px;
    padding: 0.38rem 0.55rem;
    font-size: 13px;
    border-color: #d7e4de;
    box-shadow: none;
    border-radius: 10px;
    background: #ffffff;
  }

  .bulk-edit-table .form-control:focus {
    border-color: #68b29c;
    box-shadow: 0 0 0 0.13rem rgba(0, 142, 117, 0.12);
    background: #ffffff;
  }

  .bulk-edit-cell {
    min-width: 126px;
    background: #ffffff;
    color: #334155;
    font-size: 13px;
    transition: background-color 0.15s ease, box-shadow 0.15s ease;
  }

  .bulk-edit-cell:hover {
    background: #fbfdfc;
  }

  .bulk-edit-cell span {
    display: block;
    min-height: 38px;
    padding: 10px 8px;
    line-height: 1.4;
    border-radius: 10px;
  }

  .bulk-edit-table td:nth-child(n + 5) span {
    text-align: center;
  }

  .bulk-edit-description-cell span {
    min-height: 72px;
    text-align: left !important;
    white-space: pre-wrap;
  }

  .bulk-edit-description-cell textarea.form-control {
    min-height: 82px;
    resize: vertical;
  }

  .bulk-edit-context-cell span {
    text-align: left !important;
  }

  .bulk-edit-number-cell span {
    text-align: center !important;
  }

  .bulk-edit-table td:nth-child(5),
  .bulk-edit-table th:nth-child(5),
  .bulk-edit-table td:nth-child(6),
  .bulk-edit-table th:nth-child(6),
  .bulk-edit-table td:nth-child(8),
  .bulk-edit-table th:nth-child(8),
  .bulk-edit-table td:nth-child(9),
  .bulk-edit-table th:nth-child(9),
  .bulk-edit-table td:nth-child(11),
  .bulk-edit-table th:nth-child(11),
  .bulk-edit-table td:nth-child(12),
  .bulk-edit-table th:nth-child(12) {
    min-width: 176px;
    padding-left: 14px;
    padding-right: 14px;
  }

  .bulk-edit-readonly {
    min-width: 150px;
    color: #34495a;
    font-size: 13px;
    font-weight: 600;
    background: #f8fbfa;
    line-height: 1.45;
    position: sticky;
    z-index: 1;
  }

  .bulk-edit-table td:nth-child(1),
  .bulk-edit-table th:nth-child(1) {
    position: sticky;
    left: 0;
  }

  .bulk-edit-table td:nth-child(2),
  .bulk-edit-table th:nth-child(2) {
    position: sticky;
    left: 190px;
  }

  .bulk-edit-table td:nth-child(3),
  .bulk-edit-table th:nth-child(3) {
    position: sticky;
    left: 330px;
  }

  .bulk-edit-table td:nth-child(4),
  .bulk-edit-table th:nth-child(4) {
    position: sticky;
    left: 490px;
  }

  .bulk-edit-table td:nth-child(-n + 4) {
    box-shadow: 1px 0 0 #e7efeb;
  }

  .bulk-edit-table thead th:nth-child(-n + 4) {
    z-index: 4;
  }

  .bulk-edit-apply-row th:nth-child(-n + 4) {
    z-index: 4;
  }

  .bulk-edit-select {
    min-width: 100%;
    width: 100%;
  }

  .bulk-edit-select :deep(.vs__dropdown-toggle) {
    min-height: 38px;
    border-color: #d7e4de;
    padding: 2px 8px;
    border-radius: 10px;
    background: #ffffff;
  }

  .bulk-edit-select :deep(.vs__dropdown-toggle:focus-within),
  .bulk-edit-select :deep(.vs--open .vs__dropdown-toggle) {
    border-color: #68b29c;
    box-shadow: 0 0 0 0.13rem rgba(0, 142, 117, 0.12);
  }


  .bulk-edit-table .vs__selected,
  .bulk-edit-table .vs__search,
  .bulk-edit-table .vs__search::placeholder {
    font-size: 12px;
  }

  .bulk-edit-table .vs__actions {
    padding-right: 4px;
  }

  .bulk-edit-footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 16px;
  }

  .bulk-edit-actions-cell {
    text-align: center;
    vertical-align: middle;
    min-width: 112px;
  }

  .bulk-edit-actions-panel {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 8px 10px;
    border-radius: 16px;
    border: 1px solid #d8ebe4;
    background: linear-gradient(180deg, #f8fcfa 0%, #edf6f2 100%);
    box-shadow:
      inset 0 1px 0 rgba(255, 255, 255, 0.95),
      0 12px 24px rgba(0, 142, 117, 0.08);
  }

.bulk-edit-icon-btn {
  position: relative;
  width: 42px;
  height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 14px;
  background: #ffffff;
  color: #0c5c4d !important;
  box-shadow:
    0 10px 22px rgba(15, 46, 39, 0.08),
    inset 0 1px 0 rgba(255, 255, 255, 0.92);
  transition: all 0.2s ease;
  overflow: hidden;
}

.bulk-edit-icon-btn::after {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: radial-gradient(circle at top, rgba(255, 255, 255, 0.22), transparent 60%);
  pointer-events: none;
}

.bulk-edit-icon-btn:hover {
  color: #ffffff !important;
  box-shadow:
    0 16px 28px rgba(0, 142, 117, 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.95);
  transform: translateY(-1px) scale(1.02);
}

  .bulk-edit-icon-btn i {
    position: relative;
    z-index: 1;
    font-size: 17px;
    line-height: 1;
    color: inherit !important;
    opacity: 1 !important;
  }

.bulk-edit-icon-btn-copy {
  background: linear-gradient(135deg, #14ad8c 0%, #008e75 100%);
  color: #ffffff !important;
}

.bulk-edit-icon-btn-secondary {
  border: 1px solid rgba(0, 142, 117, 0.14);
  background: linear-gradient(180deg, #ffffff 0%, #eef8f4 100%);
  color: #0c735f !important;
}

.bulk-edit-icon-btn-secondary::after {
  background: radial-gradient(circle at top, rgba(0, 142, 117, 0.14), transparent 58%);
}

.bulk-edit-icon-btn-secondary:hover {
  background: linear-gradient(135deg, #13a987 0%, #008e75 100%);
  color: #ffffff !important;
}

.bulk-edit-icon-btn-copy:hover {
  background: linear-gradient(135deg, #11a486 0%, #007864 100%);
}

.bulk-edit-icon-btn-danger {
  border: 1px solid rgba(0, 142, 117, 0.16);
  background: linear-gradient(180deg, #ffffff 0%, #f1faf7 100%);
  color: #0b6453 !important;
}

.bulk-edit-icon-btn-danger::after {
  background: radial-gradient(circle at top, rgba(0, 142, 117, 0.12), transparent 58%);
}

.bulk-edit-icon-btn-danger:hover {
  color: #ffffff !important;
  background: linear-gradient(135deg, #0e8f75 0%, #0a6d5b 100%) !important;
  box-shadow:
    0 16px 28px rgba(0, 142, 117, 0.16),
    inset 0 1px 0 rgba(255, 255, 255, 0.95);
}

.bulk-edit-icon-btn:focus,
.bulk-edit-icon-btn:active {
  outline: none;
  box-shadow:
    0 0 0 0.16rem rgba(0, 142, 117, 0.16),
    0 14px 28px rgba(0, 142, 117, 0.14);
}

.bulk-edit-icon-btn-danger:focus,
.bulk-edit-icon-btn-danger:active {
  box-shadow:
    0 0 0 0.16rem rgba(0, 142, 117, 0.14),
    0 14px 28px rgba(0, 142, 117, 0.12);
}

  .import-bula-modal {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .import-bula-intro {
    padding: 14px 16px;
    border: 1px solid #dce9e3;
    border-radius: 14px;
    background: #f8fcfa;
    color: #45635a;
    font-size: 13px;
    line-height: 1.5;
  }

  .import-bula-preview {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 16px;
    border: 1px solid #dce9e3;
    border-radius: 14px;
    background: #fcfefd;
  }

  .import-bula-preview-meta {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .import-bula-preview-label {
    color: #6b8078;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }

  .import-bula-preview-name {
    color: #23443b;
    font-weight: 600;
  }

  .import-bula-preview-source {
    color: #6b8078;
    font-size: 12px;
    line-height: 1.45;
  }

  .import-bula-preview-image {
    max-height: 320px;
    width: auto;
    max-width: 100%;
    border-radius: 12px;
    border: 1px solid #e5efea;
    object-fit: contain;
    background: #fff;
  }

  .import-bula-preview-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 140px;
    border: 1px dashed #c9ddd5;
    border-radius: 12px;
    color: #5e766f;
    font-size: 13px;
    font-weight: 600;
    background: linear-gradient(180deg, #ffffff 0%, #f6fbf8 100%);
  }

  .import-bula-footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }
}

.modal-dialog.bulk-edit-modal-shell {
  max-width: 100vw;
  width: 100vw;
  min-width: 100vw;
  margin: 0;
}

.modal.bulk-edit-modal-shell,
.bulk-edit-modal-shell {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.modal-content.bulk-edit-modal-content {
  border: 0;
  border-radius: 0;
  overflow: visible;
  width: 100vw;
  min-width: 100vw;
  min-height: 100vh;
  box-shadow: none;
}

.modal-content.bulk-edit-modal-content .modal-header {
  padding: 18px 22px;
  border-bottom: 1px solid #e6efea;
  background: #ffffff;
}

.modal-content.bulk-edit-modal-content .modal-body {
  padding: 20px 22px 22px;
  background: linear-gradient(180deg, #f7fbf9 0%, #f1f7f4 100%);
  overflow: auto;
  max-height: calc(100vh - 72px);
}

.modal-content.bulk-edit-modal-content .bulk-edit-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-bottom: 14px;
}

.modal-content.bulk-edit-modal-content .bulk-edit-count {
  font-size: 13px;
  font-weight: 700;
  color: #31574d;
}

.modal-content.bulk-edit-modal-content .bulk-edit-hint {
  display: inline-block;
  margin-left: 8px;
  color: #6d857d;
  font-size: 12px;
  font-weight: 500;
}

.modal-content.bulk-edit-modal-content .bulk-edit-toolbar-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 10px;
}

.modal-content.bulk-edit-modal-content .bulk-edit-replicate-panel {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  border: 1px solid #d9e8e2;
  border-radius: 12px;
  background: linear-gradient(180deg, #ffffff 0%, #f6fbf8 100%);
  box-shadow: 0 8px 18px rgba(15, 46, 39, 0.05);
}

.modal-content.bulk-edit-modal-content .bulk-edit-replicate-label {
  color: #6b8179;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.modal-content.bulk-edit-modal-content .bulk-edit-replicate-value {
  min-width: 150px;
  color: #23443b;
  font-size: 13px;
  font-weight: 700;
}

.modal-content.bulk-edit-modal-content .bulk-edit-table tbody tr.bulk-edit-active-row td {
  background: #f3faf7;
}

.modal-content.bulk-edit-modal-content .bulk-edit-table tbody tr.bulk-edit-active-row:hover td {
  background: #eef8f4;
}

.modal-content.bulk-edit-modal-content .bulk-edit-active-cell {
  background: #edf8f3 !important;
  box-shadow: inset 0 0 0 1px rgba(0, 142, 117, 0.16);
}

.style-select-rich .vs__dropdown-toggle {
  min-height: 44px;
  padding: 4px 10px;
  border: 1px solid #d6e6df;
  border-radius: 12px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fcfa 100%);
  transition: border-color 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}

.style-select-rich.vs--open .vs__dropdown-toggle,
.style-select-rich .vs__dropdown-toggle:focus-within {
  border-color: #69b39c;
  background: #ffffff;
  box-shadow: 0 0 0 0.14rem rgba(0, 142, 117, 0.12);
}

.style-select-rich .vs__selected-options {
  max-width: 100%;
  padding: 1px 0;
}

.style-select-rich .vs__selected,
.style-select-rich .vs__search,
.style-select-rich .vs__search::placeholder {
  max-width: 100%;
  margin: 0;
  font-size: 12px;
}

.style-select-rich .vs__actions {
  padding-right: 2px;
}

.style-select-rich .vs__dropdown-menu {
  padding: 6px;
  border: 1px solid #d8e7e1;
  border-radius: 14px;
  z-index: 40;
  box-shadow: 0 16px 36px rgba(15, 46, 39, 0.12);
}

.style-select-rich .vs__dropdown-option {
  padding: 8px 10px;
  border-radius: 10px;
}

.style-select-rich .vs__dropdown-option--highlight {
  background: linear-gradient(180deg, #eef8f4 0%, #e3f3ed 100%);
  color: #0c5c4d;
}

.select-rich-option {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  line-height: 1.15;
}

.select-rich-option-selected {
  padding-right: 6px;
}

.select-rich-title {
  color: #24433a;
  font-size: 12px;
  font-weight: 700;
  white-space: normal;
}

.select-rich-subtitle {
  color: #6f857d;
  font-size: 11px;
  font-style: italic;
  white-space: normal;
}

.modal-content.bulk-edit-modal-content .bulk-edit-select {
  width: 100%;
}

.modal-content.bulk-edit-modal-content .bulk-edit-table-wrapper {
  overflow: visible;
  max-height: none;
}

.modal-content.bulk-edit-modal-content .bulk-edit-table {
  min-width: 2460px;
}

.modal-content.bulk-edit-modal-content .bulk-edit-table .bulk-col-number-wide {
  width: 176px;
}

.modal-content.bulk-edit-modal-content .bulk-edit-cell {
  min-width: 126px;
}

.modal-content.bulk-edit-modal-content .bulk-edit-table td:nth-child(5),
.modal-content.bulk-edit-modal-content .bulk-edit-table th:nth-child(5),
.modal-content.bulk-edit-modal-content .bulk-edit-table td:nth-child(6),
.modal-content.bulk-edit-modal-content .bulk-edit-table th:nth-child(6),
.modal-content.bulk-edit-modal-content .bulk-edit-table td:nth-child(8),
.modal-content.bulk-edit-modal-content .bulk-edit-table th:nth-child(8),
.modal-content.bulk-edit-modal-content .bulk-edit-table td:nth-child(9),
.modal-content.bulk-edit-modal-content .bulk-edit-table th:nth-child(9),
.modal-content.bulk-edit-modal-content .bulk-edit-table td:nth-child(11),
.modal-content.bulk-edit-modal-content .bulk-edit-table th:nth-child(11),
.modal-content.bulk-edit-modal-content .bulk-edit-table td:nth-child(12),
.modal-content.bulk-edit-modal-content .bulk-edit-table th:nth-child(12) {
  min-width: 176px;
  width: 176px;
  padding-left: 14px;
  padding-right: 14px;
}

.modal-content.bulk-edit-modal-content .bulk-edit-cell {
  position: relative;
  overflow: visible;
}

.modal-content.bulk-edit-modal-content .bulk-edit-cell:focus-within {
  z-index: 12;
}

.modal-content.bulk-edit-modal-content .bulk-edit-select.vs--open,
.modal-content.bulk-edit-modal-content .bulk-edit-cell .vs--open,
.modal-content.bulk-edit-modal-content .bulk-edit-cell:focus-within {
  z-index: 25;
}

.modal-content.bulk-edit-modal-content .bulk-edit-number-cell > .form-control {
  position: relative;
  z-index: 1;
  min-width: 100%;
  text-align: center;
  transition: box-shadow 0.18s ease, border-color 0.18s ease;
}

.modal-content.bulk-edit-modal-content .bulk-edit-number-cell:focus-within > .form-control {
  position: relative;
  top: auto;
  left: auto;
  width: 100%;
  min-width: 100%;
  min-height: 38px;
  padding-left: 0.55rem;
  padding-right: 0.55rem;
  background: #ffffff;
  box-shadow: 0 0 0 0.14rem rgba(0, 142, 117, 0.12);
}

.modal-content.bulk-edit-modal-content .bulk-edit-select .vs__dropdown-toggle {
  min-height: 46px;
  padding: 5px 10px;
  border-radius: 12px;
}

.modal-content.bulk-edit-modal-content .bulk-edit-select .vs__dropdown-menu {
  min-width: 260px;
  z-index: 35;
  box-shadow: 0 18px 36px rgba(15, 46, 39, 0.14);
}

.modal-content.bulk-edit-modal-content .bulk-edit-select .vs__selected,
.modal-content.bulk-edit-modal-content .bulk-edit-select .vs__search,
.modal-content.bulk-edit-modal-content .bulk-edit-select .vs__search::placeholder {
  font-size: 12px;
}

.modal-content.bulk-edit-modal-content .bulk-edit-description-field {
  position: relative;
  width: 100%;
  transition: width 0.18s ease, transform 0.18s ease;
}

.modal-content.bulk-edit-modal-content .bulk-edit-description-field textarea.form-control {
  min-width: 100%;
  min-height: 82px;
  resize: vertical;
  transition: min-width 0.18s ease, min-height 0.18s ease, box-shadow 0.18s ease;
}

.modal-content.bulk-edit-modal-content .bulk-edit-description-cell:focus-within .bulk-edit-description-field {
  position: absolute;
  top: 12px;
  left: 10px;
  width: clamp(260px, 28vw, 400px);
}

.modal-content.bulk-edit-modal-content .bulk-edit-description-cell:focus-within textarea.form-control {
  min-width: 100%;
  min-height: 112px;
  background: #ffffff;
  box-shadow:
    0 0 0 0.14rem rgba(0, 142, 117, 0.12),
    0 18px 32px rgba(15, 46, 39, 0.12);
}

.modal-content.bulk-edit-modal-content .bulk-edit-table tbody td:nth-last-child(2).bulk-edit-description-cell:focus-within .bulk-edit-description-field {
  left: auto;
  right: 10px;
  transform: none;
}

.replicate-table .vs--open,
.replicate-select-cell .vs--open,
.replicate-details-grid .vs--open {
  z-index: 20;
}

.replicate-table .vs__dropdown-menu,
.replicate-details-grid .vs__dropdown-menu {
  z-index: 30;
}

.modal-content.bulk-edit-modal-content .bulk-edit-actions-cell {
  text-align: center;
  vertical-align: middle;
  min-width: 112px;
}

.modal-content.bulk-edit-modal-content .bulk-edit-actions-panel {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 2px 3px;
  border-radius: 10px;
  border: 1px solid rgba(0, 142, 117, 0.08);
  background: rgba(255, 255, 255, 0.72);
  box-shadow: 0 2px 8px rgba(0, 142, 117, 0.04);
}

.modal-content.bulk-edit-modal-content .bulk-edit-icon-btn {
  position: relative;
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.94);
  color: #0c5c4d !important;
  box-shadow:
    0 2px 6px rgba(15, 46, 39, 0.04),
    inset 0 1px 0 rgba(255, 255, 255, 0.92);
  transition: all 0.2s ease;
  overflow: hidden;
}

.modal-content.bulk-edit-modal-content .bulk-edit-icon-btn::after {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: radial-gradient(circle at top, rgba(255, 255, 255, 0.22), transparent 60%);
  pointer-events: none;
}

.modal-content.bulk-edit-modal-content .bulk-edit-icon-btn:hover {
  color: #ffffff !important;
  box-shadow:
    0 4px 10px rgba(0, 142, 117, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.95);
  transform: translateY(-1px);
}

.modal-content.bulk-edit-modal-content .bulk-edit-icon-btn i {
  position: relative;
  z-index: 1;
  font-size: 14px;
  line-height: 1;
  color: inherit !important;
  opacity: 1 !important;
}

.modal-content.bulk-edit-modal-content .bulk-edit-icon-btn-copy {
  background: linear-gradient(135deg, #f7fcfa 0%, #e8f5f0 100%);
  color: #008e75 !important;
}

.modal-content.bulk-edit-modal-content .bulk-edit-icon-btn-copy:hover {
  background: linear-gradient(135deg, #11a486 0%, #007864 100%);
  color: #ffffff !important;
}

.modal-content.bulk-edit-modal-content .bulk-edit-icon-btn-danger {
  border: 1px solid rgba(0, 142, 117, 0.1);
  background: linear-gradient(180deg, #ffffff 0%, #f6fbf9 100%);
  color: #0b6453 !important;
}

.modal-content.bulk-edit-modal-content .bulk-edit-icon-btn-danger::after {
  background: radial-gradient(circle at top, rgba(0, 142, 117, 0.12), transparent 58%);
}

.modal-content.bulk-edit-modal-content .bulk-edit-icon-btn-danger:hover {
  color: #ffffff !important;
  background: linear-gradient(135deg, #0e8f75 0%, #0a6d5b 100%) !important;
  box-shadow:
    0 4px 10px rgba(0, 142, 117, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.95);
}

.modal-content.bulk-edit-modal-content .bulk-edit-icon-btn:focus,
.modal-content.bulk-edit-modal-content .bulk-edit-icon-btn:active {
  outline: none;
  box-shadow:
    0 0 0 0.12rem rgba(0, 142, 117, 0.12),
    0 4px 10px rgba(0, 142, 117, 0.08);
}

.modal-content.bulk-edit-modal-content .bulk-edit-icon-btn-danger:focus,
.modal-content.bulk-edit-modal-content .bulk-edit-icon-btn-danger:active {
  box-shadow:
    0 0 0 0.12rem rgba(0, 142, 117, 0.12),
    0 4px 10px rgba(0, 142, 117, 0.08);
}

.import-bula-modal-content {
  border: 0;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 24px 60px rgba(15, 46, 39, 0.18);
}

.import-bula-modal-content .modal-header {
  padding: 18px 22px;
  border-bottom: 1px solid #e6efea;
  background: #ffffff;
}

.import-bula-modal-content .modal-body {
  padding: 20px 22px 22px;
  background: linear-gradient(180deg, #f7fbf9 0%, #f1f7f4 100%);
}

.import-bula-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
}

.import-bula-agrofit-card {
  margin-bottom: 16px;
  padding: 16px 18px;
  border: 1px solid #d9e9e2;
  border-radius: 16px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, rgba(247, 251, 249, 0.98) 100%);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9);
}

.import-bula-agrofit-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;
}

.import-bula-agrofit-title {
  color: #1f4e44;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.import-bula-agrofit-subtitle {
  margin-top: 4px;
  color: #5f746d;
  font-size: 12px;
  line-height: 1.45;
}

.import-bula-chip-btn {
  padding: 0.42rem 0.78rem;
  border: 1px solid #cfe2db;
  border-radius: 999px;
  background: #ffffff;
  color: #0d5c4e;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
  box-shadow: 0 8px 18px rgba(12, 92, 77, 0.06);
  transition: all 0.18s ease;
  white-space: nowrap;
}

.import-bula-chip-btn:hover {
  border-color: #b8d5ca;
  background: #f7fcfa;
  color: #084b3e;
}

.import-bula-agrofit-state {
  padding: 12px 14px;
  border: 1px dashed #cfe0da;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.72);
  color: #5d746d;
  font-size: 13px;
}

.import-bula-culture-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 10px;
}

.import-bula-culture-option {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  min-height: 72px;
  margin: 0;
  padding: 12px 14px;
  border: 1px solid #dbe8e3;
  border-radius: 14px;
  background: #ffffff;
  cursor: pointer;
  transition: all 0.18s ease;
}

.import-bula-culture-option:hover {
  border-color: #b9d8cd;
  background: #f9fcfb;
  box-shadow: 0 10px 20px rgba(12, 92, 77, 0.06);
}

.import-bula-culture-option input {
  margin-top: 3px;
  accent-color: #008e75;
}

.import-bula-culture-copy {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.import-bula-culture-name {
  color: #21493f;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.35;
}

.import-bula-culture-meta {
  color: #6e817b;
  font-size: 11px;
  line-height: 1.45;
}

.import-bula-prompt-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0.42rem 0.82rem;
  border: 1px solid rgba(0, 142, 117, 0.18) !important;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.88) !important;
  color: #0d5c4e !important;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.4;
  letter-spacing: 0.01em;
  box-shadow: 0 8px 20px rgba(12, 92, 77, 0.08);
  backdrop-filter: blur(8px);
  transition: all 0.18s ease;
  white-space: nowrap;
}

.import-bula-prompt-btn::before {
  content: '';
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: linear-gradient(180deg, #12b28f 0%, #008e75 100%);
  box-shadow: 0 0 0 4px rgba(0, 142, 117, 0.12);
  flex: 0 0 auto;
}

.import-bula-prompt-btn:hover {
  border-color: rgba(0, 142, 117, 0.34) !important;
  background: linear-gradient(180deg, #ffffff 0%, #f2faf7 100%) !important;
  color: #084b3e !important;
  box-shadow: 0 12px 24px rgba(0, 142, 117, 0.12);
  transform: translateY(-1px);
}

.import-bula-prompt-btn:focus,
.import-bula-prompt-btn:active {
  color: #084b3e !important;
  background: linear-gradient(180deg, #ffffff 0%, #f2faf7 100%) !important;
  border-color: rgba(0, 142, 117, 0.4) !important;
  box-shadow: 0 0 0 0.18rem rgba(0, 142, 117, 0.12), 0 10px 24px rgba(0, 142, 117, 0.1) !important;
  outline: none;
}

.comparativo-culturas-modal-content {
  border: 0;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 24px 60px rgba(15, 46, 39, 0.18);
}

.comparativo-culturas-modal-content .modal-header {
  padding: 18px 22px;
  border-bottom: 1px solid #e6efea;
  background: #ffffff;
}

.comparativo-culturas-modal-content .modal-body {
  padding: 20px 22px 22px;
  background: linear-gradient(180deg, #f7fbf9 0%, #f1f7f4 100%);
}

.comparativo-culturas-intro {
  margin-bottom: 16px;
  color: #536b63;
  font-size: 13px;
  line-height: 1.6;
}

.comparativo-culturas-state {
  padding: 18px;
  border: 1px dashed #cfe0da;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.78);
  color: #5d746d;
  font-size: 13px;
}

.comparativo-culturas-grid {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.comparativo-count-strip {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.comparativo-count-pill {
  padding: 8px 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid #d7e7e1;
  color: #48645c;
  font-size: 12px;
  font-weight: 700;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9);
}

.comparativo-count-pill-highlight {
  border-color: #b8ddd0;
  background: linear-gradient(180deg, #ffffff 0%, #eef8f4 100%);
  color: #0d6b59;
}

.comparativo-culturas-summary {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.comparativo-summary-card,
.comparativo-list-card {
  padding: 16px;
  border: 1px solid #d9e9e2;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9);
}

.comparativo-summary-label {
  display: block;
  margin-bottom: 6px;
  color: #587069;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.comparativo-summary-value {
  display: block;
  color: #1e4f43;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.4;
}

.comparativo-summary-meta {
  display: block;
  margin-top: 4px;
  color: #6d817a;
  font-size: 12px;
  line-height: 1.45;
}

.comparativo-list-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.comparativo-list-card-highlight {
  border-color: #b8ddd0;
  background: linear-gradient(180deg, #ffffff 0%, #f4fbf8 100%);
}

.comparativo-list-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.comparativo-list-title {
  color: #1f4e44;
  font-size: 13px;
  font-weight: 800;
}

.comparativo-action-btn {
  padding: 0.5rem 0.85rem;
  border: 1px solid rgba(0, 142, 117, 0.18);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.95);
  color: #0d5c4e;
  font-size: 12px;
  font-weight: 700;
  transition: all 0.18s ease;
  white-space: nowrap;
}

.comparativo-action-btn:hover:not(:disabled) {
  border-color: rgba(0, 142, 117, 0.32);
  background: #f6fcfa;
  color: #084b3e;
}

.comparativo-action-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.comparativo-list {
  margin: 0;
  padding-left: 18px;
  color: #425b54;
  font-size: 13px;
  line-height: 1.6;
}

.comparativo-list-item {
  margin-bottom: 10px;
}

.comparativo-list-item:last-child {
  margin-bottom: 0;
}

.comparativo-select-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 0;
  cursor: pointer;
}

.comparativo-select-item input {
  margin-top: 4px;
  accent-color: #008e75;
}

.comparativo-select-copy {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.comparativo-list-item-title {
  display: block;
  color: #21493f;
  font-weight: 700;
  line-height: 1.4;
}

.comparativo-list-item-meta {
  display: block;
  color: #70847d;
  font-size: 12px;
  line-height: 1.45;
}

.comparativo-list-item-highlight .comparativo-list-item-title {
  color: #0f6d5b;
}

.comparativo-inline-link {
  margin-top: 8px;
  margin-left: 26px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #0d6b59;
  font-size: 12px;
  font-weight: 700;
  text-decoration: underline;
}

.comparativo-inline-link:hover {
  color: #084b3e;
}

.comparativo-list-empty {
  list-style: none;
  margin-left: -18px;
  color: #7b8d87;
}

.comparativo-culturas-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 18px;
}

.replicate-modal-shell .modal-dialog {
  max-width: 96vw;
  width: 96vw;
}

.replicate-modal-content {
  border: 0;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 24px 60px rgba(15, 46, 39, 0.22);
}

.replicate-modal-content .modal-header {
  padding: 18px 22px;
  border-bottom: 1px solid #e6efea;
  background: #ffffff;
}

.replicate-modal-content .modal-body {
  padding: 20px 22px 22px;
  background: linear-gradient(180deg, #f7fbf9 0%, #f1f7f4 100%);
}

.replicate-modal {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.replicate-summary {
  padding: 16px 18px;
  border: 1px solid #dfe9e4;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 6px 18px rgba(12, 92, 77, 0.05);
}

.replicate-summary-title,
.replicate-toolbar-title {
  font-size: 16px;
  font-weight: 700;
  color: #0c5c4d;
}

.replicate-summary-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  margin-top: 14px;
}

.replicate-summary-item {
  padding: 12px;
  border: 1px solid #edf3f0;
  border-radius: 12px;
  background: #f9fcfb;
}

.replicate-summary-label {
  display: block;
  margin-bottom: 4px;
  font-size: 11px;
  font-weight: 700;
  color: #6a8279;
  text-transform: uppercase;
}

.replicate-summary-value {
  color: #1f4037;
  font-weight: 600;
}

.replicate-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.replicate-table-wrapper {
  overflow: auto;
  border: 1px solid #dfe8e3;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 8px 24px rgba(12, 92, 77, 0.06);
}

.replicate-table {
  width: 100%;
  min-width: 1520px;
  border-collapse: separate;
  border-spacing: 0;
}

.replicate-table th,
.replicate-table td {
  padding: 8px;
  border-bottom: 1px solid #edf2ef;
  vertical-align: top;
}

.replicate-table th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #f5faf8;
  color: #47675e;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.25;
  white-space: normal;
  padding: 12px 8px;
}

.replicate-table tbody tr:nth-child(even) td {
  background: #fbfdfc;
}

.replicate-table tbody tr:hover td {
  background: #f3faf6;
}

.replicate-table tbody tr:last-child td {
  border-bottom: 0;
}

.replicate-row-index {
  min-width: 52px;
  text-align: center;
  font-weight: 700;
  color: #31574d;
  padding-top: 16px;
}

.replicate-select-cell {
  min-width: 210px;
}

.replicate-select {
  min-width: 210px;
}

.replicate-check-cell {
  min-width: 88px;
  text-align: center;
  padding-top: 18px !important;
}

.replicate-actions-cell {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 132px;
}

.replicate-expand-cell {
  min-width: 98px;
  text-align: center;
  padding-top: 12px !important;
}

.replicate-details-row td {
  padding: 0 !important;
  background: #f8fcfa !important;
}

.replicate-details-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;
  padding: 14px;
}

.replicate-detail-field {
  min-width: 0;
}

.replicate-detail-field label {
  display: block;
  margin-bottom: 6px;
  font-size: 11px;
  font-weight: 700;
  color: #617970;
  text-transform: uppercase;
}

.replicate-detail-text {
  grid-column: span 5;
}

.replicate-table .form-control {
  min-height: 38px;
  min-width: 72px;
  border-color: #d7e4de;
  box-shadow: none;
  font-size: 13px;
  color: #24433a;
  padding: 0.45rem 0.55rem;
}

.replicate-table textarea.form-control {
  min-height: 68px;
  min-width: 280px;
  resize: vertical;
}

.replicate-table .vs__dropdown-toggle {
  min-height: 38px;
  border: 1px solid #d7e4de;
  border-radius: 0.35rem;
  background: #fff;
  padding: 3px 8px;
}

.replicate-table .vs__selected {
  font-size: 13px;
  color: #294840;
}

.replicate-table .vs__search,
.replicate-table .vs__search::placeholder {
  font-size: 13px;
}

.replicate-table .vs--open .vs__dropdown-toggle,
.replicate-table .form-control:focus {
  border-color: #7fb7a0;
  box-shadow: 0 0 0 0.12rem rgba(0, 142, 117, 0.12);
}

.replicate-actions-cell .btn {
  white-space: nowrap;
}

.replicate-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding-top: 8px;
}

@media (max-width: 991px) {
  .replicate-modal-shell .modal-dialog {
    max-width: 98vw;
    width: 98vw;
    margin: 0.5rem auto;
  }

  .replicate-summary-grid {
    grid-template-columns: 1fr 1fr;
  }

  .replicate-toolbar,
  .replicate-footer {
    flex-direction: column;
    align-items: stretch;
  }

  .replicate-details-grid {
    grid-template-columns: 1fr;
  }

  .replicate-detail-text {
    grid-column: span 1;
  }
}
</style>
